
import { printf, toFail } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { item } from "../../fable_modules/fable-library-js.5.13.0/Array.js";
import { op_BitwiseOr, op_ExclusiveOr, op_LeftShift, op_Subtraction, op_Multiply, fromOne, op_BitwiseAnd, op_RightShift, toUInt32_unchecked, op_Addition, toUInt64_unchecked, fromZero, fromUInt32, equals, toUInt32 } from "../../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { twosComp } from "../NumberHelpers.js";
import { bigIntMask, getBitsFromBigIntToUInt32, getBitsFromBigInt, getBitsFromUInt32 } from "../SimGraphTypes.js";
import { Exception } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { iterateIndexed2 } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { getRamStore, writeRamAddrUInt32DataBigInt, readRamAddrUInt32DataBigInt, writeRamAddrBigIntDataUInt32, readRamAddrBigIntDataUInt32, writeRamAddrBigIntDataBigInt, readRamAddrBigIntDataBigInt, writeRamAddrUInt32DataUInt32, readRamAddrUInt32DataUInt32, ramStoreOf, getRamState, readMemoryAddrUInt32DataBigInt, readMemoryAddrBigIntDataUInt32, readMemoryAddrBigIntDataBigInt, readMemoryAddrUInt32DataUInt32 } from "./EvalKernel.js";
import { reset } from "../RamStore.js";
import { StepIndex } from "../SimTypes.js";

/**
 * Given a component, compute its outputs from its inputs, which must already be evaluated.
 * Outputs and inputs are both contained as time sequences in arrays. This function will calculate
 * simStep outputs from (previously calculated) simStep outputs and clocked (simStep-1) outputs.
 * Memory has state separate from simStep-1 output, for this the state is recalculated.
 * Inputs and outputs come from either the UInt32 or BigInt slab region of the IOArray record.
 */
export function fastReduce(step, isClockedReduction, comp) {
    let this$_34, this$_37, this$_45, this$_48, this$_52, gateType_4, this$_63, this$_68, this$_108, this$_114, this$_223, this$_224, this$_227, this$_228, this$_231, this$_232, this$_235, this$_236, this$_253, this$_257, this$_262, this$_282, this$_277, this$_272, this$_267, this$_304, this$_308, this$_310, this$_393, this$_403, this$_411, this$_418, this$_423, this$_429, this$_435, this$_436, this$_439, this$_443, this$_449, this$_446, this$_454, this$_458, this$_464, this$_461, this$_508, this$_519, this$_537, this$_528;
    const componentType = comp.FType;
    const numStep = step.NumStep | 0;
    const simStep = step.SimStep | 0;
    const simStepOld = step.SimStepOld | 0;
    const matchValue = comp.UseBigInt;
    let matchResult, width, width_2, cVal, width_4, cVal_1, width_5, width_6, width_8, width_10, width_12, lsb, width_14, lsb_1, width_15, compareVal, width_16, compareVal_1, width_17, gateType, n_22, numberOfBits, numberOfBits_1, numberOfBits_2, numberOfBits_3, numberOfBits_4, op, numberOfBits_5, op_1, numberOfBits_6, numberOfBits_7, numberOfBits_8, numberOfBits_9, numberOfBits_10, numberOfBits_11, numberOfBits_12, numberOfBits_13, shiftType, width_18, shiftType_1, width_19, c, n_102, n_105, n_108, n_111, n_114, n_116, topWireWidth, lsBits, n_121, outputWidths, lsBits_1, n_123, outputWidths_1, topWireWidth_1, width_22, width_23, width_24, width_25, width_26, width_28, width_29, width_31, width_32, width_34, width_35, width_37, mem, mem_1, mem_2, mem_3, memory, memory_1, memory_2, mem_8;
    switch (componentType.tag) {
        case 44:
        case 45:
        case 43: {
            matchResult = 0;
            break;
        }
        case 48: {
            matchResult = 1;
            break;
        }
        case 4: {
            matchResult = 12;
            break;
        }
        case 0: {
            if (matchValue) {
                matchResult = 3;
                width_2 = componentType.fields[0];
            }
            else {
                matchResult = 2;
                width = componentType.fields[0];
            }
            break;
        }
        case 7: {
            if (matchValue) {
                matchResult = 5;
                cVal_1 = componentType.fields[1];
                width_5 = componentType.fields[0];
            }
            else {
                matchResult = 4;
                cVal = componentType.fields[1];
                width_4 = componentType.fields[0];
            }
            break;
        }
        case 49: {
            if (matchValue) {
                matchResult = 5;
                cVal_1 = componentType.fields[1];
                width_5 = componentType.fields[0];
            }
            else {
                matchResult = 4;
                cVal = componentType.fields[1];
                width_4 = componentType.fields[0];
            }
            break;
        }
        case 1: {
            if (matchValue) {
                matchResult = 7;
                width_8 = componentType.fields[0];
            }
            else {
                matchResult = 6;
                width_6 = componentType.fields[0];
            }
            break;
        }
        case 2: {
            if (matchValue) {
                matchResult = 9;
                width_12 = componentType.fields[0];
            }
            else {
                matchResult = 8;
                width_10 = componentType.fields[0];
            }
            break;
        }
        case 3: {
            if (matchValue) {
                matchResult = 11;
            }
            else {
                matchResult = 10;
            }
            break;
        }
        case 8: {
            if (matchValue) {
                matchResult = 19;
            }
            else {
                matchResult = 13;
            }
            break;
        }
        case 6: {
            if (matchValue) {
                matchResult = 15;
                lsb_1 = componentType.fields[1];
                width_15 = componentType.fields[0];
            }
            else {
                matchResult = 14;
                lsb = componentType.fields[1];
                width_14 = componentType.fields[0];
            }
            break;
        }
        case 47: {
            if (matchValue) {
                matchResult = 17;
                compareVal_1 = componentType.fields[1];
                width_17 = componentType.fields[0];
            }
            else {
                matchResult = 16;
                compareVal = componentType.fields[1];
                width_16 = componentType.fields[0];
            }
            break;
        }
        case 5: {
            if (matchValue) {
                matchResult = 17;
                compareVal_1 = componentType.fields[1];
                width_17 = componentType.fields[0];
            }
            else {
                matchResult = 16;
                compareVal = componentType.fields[1];
                width_16 = componentType.fields[0];
            }
            break;
        }
        case 10: {
            if (matchValue) {
                matchResult = 19;
            }
            else {
                matchResult = 18;
                gateType = componentType.fields[0];
                n_22 = componentType.fields[1];
            }
            break;
        }
        case 11: {
            if (matchValue) {
                matchResult = 21;
            }
            else {
                matchResult = 20;
            }
            break;
        }
        case 12: {
            if (matchValue) {
                matchResult = 23;
            }
            else {
                matchResult = 22;
            }
            break;
        }
        case 13: {
            if (matchValue) {
                matchResult = 25;
            }
            else {
                matchResult = 24;
            }
            break;
        }
        case 14: {
            if (matchValue) {
                matchResult = 27;
            }
            else {
                matchResult = 26;
            }
            break;
        }
        case 15: {
            if (matchValue) {
                matchResult = 29;
            }
            else {
                matchResult = 28;
            }
            break;
        }
        case 16: {
            if (matchValue) {
                matchResult = 31;
            }
            else {
                matchResult = 30;
            }
            break;
        }
        case 17: {
            if (matchValue) {
                matchResult = 33;
                numberOfBits_1 = componentType.fields[0];
            }
            else {
                matchResult = 32;
                numberOfBits = componentType.fields[0];
            }
            break;
        }
        case 19: {
            if (matchValue) {
                matchResult = 33;
                numberOfBits_1 = componentType.fields[0];
            }
            else {
                matchResult = 32;
                numberOfBits = componentType.fields[0];
            }
            break;
        }
        case 18: {
            if (matchValue) {
                matchResult = 35;
                numberOfBits_3 = componentType.fields[0];
            }
            else {
                matchResult = 34;
                numberOfBits_2 = componentType.fields[0];
            }
            break;
        }
        case 20: {
            if (matchValue) {
                matchResult = 35;
                numberOfBits_3 = componentType.fields[0];
            }
            else {
                matchResult = 34;
                numberOfBits_2 = componentType.fields[0];
            }
            break;
        }
        case 21: {
            if (matchValue) {
                matchResult = 37;
                numberOfBits_5 = componentType.fields[0];
                op_1 = componentType.fields[1];
            }
            else {
                matchResult = 36;
                numberOfBits_4 = componentType.fields[0];
                op = componentType.fields[1];
            }
            break;
        }
        case 24: {
            if (matchValue) {
                matchResult = 39;
                numberOfBits_7 = componentType.fields[0];
            }
            else {
                matchResult = 38;
                numberOfBits_6 = componentType.fields[0];
            }
            break;
        }
        case 22: {
            if (matchValue) {
                matchResult = 41;
                numberOfBits_9 = componentType.fields[0];
            }
            else {
                matchResult = 40;
                numberOfBits_8 = componentType.fields[0];
            }
            break;
        }
        case 23: {
            if (matchValue) {
                matchResult = 43;
                numberOfBits_11 = componentType.fields[0];
            }
            else {
                matchResult = 42;
                numberOfBits_10 = componentType.fields[0];
            }
            break;
        }
        case 25: {
            if (matchValue) {
                matchResult = 45;
                numberOfBits_13 = componentType.fields[0];
            }
            else {
                matchResult = 44;
                numberOfBits_12 = componentType.fields[0];
            }
            break;
        }
        case 46: {
            if (matchValue) {
                matchResult = 47;
                shiftType_1 = componentType.fields[2];
                width_19 = componentType.fields[0];
            }
            else {
                matchResult = 46;
                shiftType = componentType.fields[2];
                width_18 = componentType.fields[0];
            }
            break;
        }
        case 26: {
            matchResult = 48;
            c = componentType.fields[0];
            break;
        }
        case 27: {
            if (matchValue) {
                matchResult = 50;
            }
            else {
                matchResult = 49;
            }
            break;
        }
        case 29: {
            if (matchValue) {
                matchResult = 52;
                n_105 = componentType.fields[0];
            }
            else {
                matchResult = 51;
                n_102 = componentType.fields[0];
            }
            break;
        }
        case 54: {
            if (matchValue) {
                matchResult = 54;
                n_111 = componentType.fields[0];
            }
            else {
                matchResult = 53;
                n_108 = componentType.fields[0];
            }
            break;
        }
        case 55: {
            if (matchValue) {
                matchResult = 56;
                n_116 = componentType.fields[0];
            }
            else {
                matchResult = 55;
                n_114 = componentType.fields[0];
            }
            break;
        }
        case 28: {
            if (matchValue) {
                matchResult = 60;
                topWireWidth_1 = componentType.fields[0];
            }
            else {
                matchResult = 57;
                topWireWidth = componentType.fields[0];
            }
            break;
        }
        case 30: {
            if (matchValue) {
                matchResult = 59;
                lsBits_1 = componentType.fields[2];
                n_123 = componentType.fields[0];
                outputWidths_1 = componentType.fields[1];
            }
            else {
                matchResult = 58;
                lsBits = componentType.fields[2];
                n_121 = componentType.fields[0];
                outputWidths = componentType.fields[1];
            }
            break;
        }
        case 31: {
            if (matchValue) {
                matchResult = 63;
            }
            else {
                matchResult = 61;
            }
            break;
        }
        case 32: {
            if (matchValue) {
                matchResult = 63;
            }
            else {
                matchResult = 62;
            }
            break;
        }
        case 33: {
            if (matchValue) {
                matchResult = 65;
                width_23 = componentType.fields[0];
            }
            else {
                matchResult = 64;
                width_22 = componentType.fields[0];
            }
            break;
        }
        case 34: {
            if (matchValue) {
                matchResult = 67;
                width_25 = componentType.fields[0];
            }
            else {
                matchResult = 66;
                width_24 = componentType.fields[0];
            }
            break;
        }
        case 35: {
            if (matchValue) {
                matchResult = 69;
                width_28 = componentType.fields[0];
            }
            else {
                matchResult = 68;
                width_26 = componentType.fields[0];
            }
            break;
        }
        case 37: {
            if (matchValue) {
                matchResult = 71;
                width_31 = componentType.fields[0];
            }
            else {
                matchResult = 70;
                width_29 = componentType.fields[0];
            }
            break;
        }
        case 36: {
            if (matchValue) {
                matchResult = 73;
                width_34 = componentType.fields[0];
            }
            else {
                matchResult = 72;
                width_32 = componentType.fields[0];
            }
            break;
        }
        case 38: {
            if (matchValue) {
                matchResult = 75;
                width_37 = componentType.fields[0];
            }
            else {
                matchResult = 74;
                width_35 = componentType.fields[0];
            }
            break;
        }
        case 39: {
            if (matchValue) {
                matchResult = 77;
                mem_1 = componentType.fields[0];
            }
            else {
                matchResult = 76;
                mem = componentType.fields[0];
            }
            break;
        }
        case 40: {
            if (matchValue) {
                matchResult = 79;
                mem_3 = componentType.fields[0];
            }
            else {
                matchResult = 78;
                mem_2 = componentType.fields[0];
            }
            break;
        }
        case 41: {
            if (matchValue) {
                matchResult = 81;
                memory_1 = componentType.fields[0];
            }
            else {
                matchResult = 80;
                memory = componentType.fields[0];
            }
            break;
        }
        case 42: {
            if (matchValue) {
                matchResult = 83;
                mem_8 = componentType.fields[0];
            }
            else {
                matchResult = 82;
                memory_2 = componentType.fields[0];
            }
            break;
        }
        default:
            matchResult = 84;
    }
    switch (matchResult) {
        case 0: {
            toFail(printf("What? Legacy RAM component types should never occur"));
            break;
        }
        case 1: {
            toFail(printf("Legacy Input component types should never occur"));
            break;
        }
        case 2: {
            if (comp.Active) {
                let bits;
                const this$ = item(0, comp.InputLinks);
                bits = (this$.UInt32Slab[(this$.StepBase + simStep)]);
                item(0, comp.InputLinks).Width;
                const this$_3 = item(0, comp.Outputs);
                this$_3.UInt32Slab[(this$_3.StepBase + simStep)] = bits;
            }
            break;
        }
        case 3: {
            if (comp.Active) {
                let bits_1;
                const this$_4 = item(0, comp.InputLinks);
                bits_1 = (this$_4.BigIntSlab[(this$_4.StepBase + simStep)]);
                item(0, comp.InputLinks).Width;
                const this$_7 = item(0, comp.Outputs);
                this$_7.BigIntSlab[(this$_7.StepBase + simStep)] = bits_1;
            }
            break;
        }
        case 4: {
            const fd_2 = toUInt32(twosComp(width_4, cVal)) >>> 0;
            const this$_9 = item(0, comp.Outputs);
            this$_9.UInt32Slab[(this$_9.StepBase + simStep)] = fd_2;
            break;
        }
        case 5: {
            const fd_3 = twosComp(width_5, cVal_1);
            const this$_11 = item(0, comp.Outputs);
            this$_11.BigIntSlab[(this$_11.StepBase + simStep)] = fd_3;
            break;
        }
        case 6: {
            let bits_2;
            const this$_12 = item(0, comp.InputLinks);
            bits_2 = (this$_12.UInt32Slab[(this$_12.StepBase + simStep)]);
            item(0, comp.InputLinks).Width;
            const this$_15 = item(0, comp.Outputs);
            this$_15.UInt32Slab[(this$_15.StepBase + simStep)] = bits_2;
            break;
        }
        case 7: {
            let bits_3;
            const this$_16 = item(0, comp.InputLinks);
            bits_3 = (this$_16.BigIntSlab[(this$_16.StepBase + simStep)]);
            item(0, comp.InputLinks).Width;
            const this$_19 = item(0, comp.Outputs);
            this$_19.BigIntSlab[(this$_19.StepBase + simStep)] = bits_3;
            break;
        }
        case 8: {
            let bits_4;
            const this$_20 = item(0, comp.InputLinks);
            bits_4 = (this$_20.UInt32Slab[(this$_20.StepBase + simStep)]);
            item(0, comp.InputLinks).Width;
            const this$_23 = item(0, comp.Outputs);
            this$_23.UInt32Slab[(this$_23.StepBase + simStep)] = bits_4;
            break;
        }
        case 9: {
            let bits_5;
            const this$_24 = item(0, comp.InputLinks);
            bits_5 = (this$_24.BigIntSlab[(this$_24.StepBase + simStep)]);
            item(0, comp.InputLinks).Width;
            const this$_27 = item(0, comp.Outputs);
            this$_27.BigIntSlab[(this$_27.StepBase + simStep)] = bits_5;
            break;
        }
        case 10: {
            let fd_8;
            const this$_28 = item(0, comp.InputLinks);
            fd_8 = (this$_28.UInt32Slab[(this$_28.StepBase + simStep)]);
            const this$_30 = item(0, comp.Outputs);
            this$_30.UInt32Slab[(this$_30.StepBase + simStep)] = fd_8;
            break;
        }
        case 11: {
            let fd_9;
            const this$_31 = item(0, comp.InputLinks);
            fd_9 = (this$_31.BigIntSlab[(this$_31.StepBase + simStep)]);
            const this$_33 = item(0, comp.Outputs);
            this$_33.BigIntSlab[(this$_33.StepBase + simStep)] = fd_9;
            break;
        }
        case 12: {
            break;
        }
        case 13: {
            const fd_10 = (((this$_34 = item(0, comp.InputLinks), this$_34.UInt32Slab[(this$_34.StepBase + simStep)])) ^ 1) >>> 0;
            const this$_36 = item(0, comp.Outputs);
            this$_36.UInt32Slab[(this$_36.StepBase + simStep)] = fd_10;
            break;
        }
        case 14: {
            const fd_11 = getBitsFromUInt32((lsb + width_14) - 1, lsb, (this$_37 = item(0, comp.InputLinks), this$_37.UInt32Slab[(this$_37.StepBase + simStep)]));
            const this$_39 = item(0, comp.Outputs);
            this$_39.UInt32Slab[(this$_39.StepBase + simStep)] = fd_11;
            break;
        }
        case 15: {
            let bits_9;
            const this$_40 = item(0, comp.InputLinks);
            bits_9 = (this$_40.BigIntSlab[(this$_40.StepBase + simStep)]);
            const matchValue_2 = comp.BigIntState;
            if (matchValue_2 != null) {
                if (item(0, matchValue_2.OutputIsBigInt)) {
                    const fd_12 = getBitsFromBigInt((lsb_1 + width_15) - 1, lsb_1, bits_9);
                    const this$_42 = item(0, comp.Outputs);
                    this$_42.BigIntSlab[(this$_42.StepBase + simStep)] = fd_12;
                }
                else {
                    const fd_13 = getBitsFromBigIntToUInt32((lsb_1 + width_15) - 1, lsb_1, bits_9);
                    const this$_44 = item(0, comp.Outputs);
                    this$_44.UInt32Slab[(this$_44.StepBase + simStep)] = fd_13;
                }
            }
            else {
                throw new Exception("This should never happen, BusSelection with UseBigInt = true must have Some(BigIntState), but get None");
            }
            break;
        }
        case 16: {
            const fd_14 = equals(fromUInt32((this$_45 = item(0, comp.InputLinks), this$_45.UInt32Slab[(this$_45.StepBase + simStep)])), compareVal) ? 1 : 0;
            const this$_47 = item(0, comp.Outputs);
            this$_47.UInt32Slab[(this$_47.StepBase + simStep)] = fd_14;
            break;
        }
        case 17: {
            const fd_15 = equals((this$_48 = item(0, comp.InputLinks), this$_48.BigIntSlab[(this$_48.StepBase + simStep)]), compareVal_1) ? 1 : 0;
            const this$_50 = item(0, comp.Outputs);
            this$_50.UInt32Slab[(this$_50.StepBase + simStep)] = fd_15;
            break;
        }
        case 18: {
            if (n_22 === 2) {
                let bitOp;
                const gateType_1 = gateType;
                bitOp = ((gateType_1 === "or") ? ((bit_2_1) => ((bit_3) => ((bit_2_1 | bit_3) >>> 0))) : ((gateType_1 === "xor") ? ((bit_4) => ((bit_5) => ((bit_4 ^ bit_5) >>> 0))) : ((gateType_1 === "nand") ? ((bit_6) => ((bit_7) => ((((bit_6 & bit_7) >>> 0) ^ 1) >>> 0))) : ((gateType_1 === "nor") ? ((bit_8_1) => ((bit_9_1) => ((((bit_8_1 | bit_9_1) >>> 0) ^ 1) >>> 0))) : ((gateType_1 === "xnor") ? ((bit_10_1) => ((bit_11_1) => ((((bit_10_1 ^ bit_11_1) >>> 0) ^ 1) >>> 0))) : ((bit_2) => ((bit_1_1) => ((bit_2 & bit_1_1) >>> 0))))))));
                let matchValue_3;
                const this$_51 = item(0, comp.InputLinks);
                matchValue_3 = (this$_51.UInt32Slab[(this$_51.StepBase + simStep)]);
                const fd_16 = bitOp((this$_52 = item(1, comp.InputLinks), this$_52.UInt32Slab[(this$_52.StepBase + simStep)]))(matchValue_3);
                const this$_54 = item(0, comp.Outputs);
                this$_54.UInt32Slab[(this$_54.StepBase + simStep)] = fd_16;
            }
            else {
                const gateType_2 = gateType;
                let gateResult;
                const this$_55 = item(0, comp.InputLinks);
                gateResult = (this$_55.UInt32Slab[(this$_55.StepBase + simStep)]);
                for (let gateInputNum = 1; gateInputNum <= (n_22 - 1); gateInputNum++) {
                    let gateType_3, this$_56;
                    gateResult = ((gateType_3 = gateType_2, (gateType_3 === "nand") ? ((bit_14) => ((bit_1_2) => ((bit_14 & bit_1_2) >>> 0))) : ((gateType_3 === "or") ? ((bit_2_2) => ((bit_3_1) => ((bit_2_2 | bit_3_1) >>> 0))) : ((gateType_3 === "nor") ? ((bit_2_2) => ((bit_3_1) => ((bit_2_2 | bit_3_1) >>> 0))) : ((gateType_3 === "xor") ? ((bit_4_1) => ((bit_5_1) => ((bit_4_1 ^ bit_5_1) >>> 0))) : ((gateType_3 === "xnor") ? ((bit_4_1) => ((bit_5_1) => ((bit_4_1 ^ bit_5_1) >>> 0))) : ((bit_14) => ((bit_1_2) => ((bit_14 & bit_1_2) >>> 0)))))))))(gateResult)((this$_56 = item(gateInputNum, comp.InputLinks), this$_56.UInt32Slab[(this$_56.StepBase + simStep)]));
                }
                if ((gateType_4 = gateType_2, (gateType_4 === "nor") ? true : ((gateType_4 === "xnor") ? true : ((gateType_4 === "and") ? false : ((gateType_4 === "or") ? false : (!(gateType_4 === "xor"))))))) {
                    const fd_17 = (gateResult ^ 1) >>> 0;
                    const this$_58 = item(0, comp.Outputs);
                    this$_58.UInt32Slab[(this$_58.StepBase + simStep)] = fd_17;
                }
                else {
                    const fd_18 = gateResult;
                    const this$_60 = item(0, comp.Outputs);
                    this$_60.UInt32Slab[(this$_60.StepBase + simStep)] = fd_18;
                }
            }
            break;
        }
        case 19: {
            throw new Exception("This should never happen, 1-bit component should not use BigInt");
            break;
        }
        case 20: {
            let matchValue_5;
            const this$_61 = item(0, comp.InputLinks);
            matchValue_5 = (this$_61.UInt32Slab[(this$_61.StepBase + simStep)]);
            let matchValue_6;
            const this$_62 = item(1, comp.InputLinks);
            matchValue_6 = (this$_62.UInt32Slab[(this$_62.StepBase + simStep)]);
            const fd_19 = (((this$_63 = item(2, comp.InputLinks), this$_63.UInt32Slab[(this$_63.StepBase + simStep)])) === 0) ? matchValue_5 : matchValue_6;
            const this$_65 = item(0, comp.Outputs);
            this$_65.UInt32Slab[(this$_65.StepBase + simStep)] = fd_19;
            break;
        }
        case 21: {
            let matchValue_8;
            const this$_66 = item(0, comp.InputLinks);
            matchValue_8 = (this$_66.BigIntSlab[(this$_66.StepBase + simStep)]);
            let matchValue_9;
            const this$_67 = item(1, comp.InputLinks);
            matchValue_9 = (this$_67.BigIntSlab[(this$_67.StepBase + simStep)]);
            const fd_20 = (((this$_68 = item(2, comp.InputLinks), this$_68.UInt32Slab[(this$_68.StepBase + simStep)])) === 0) ? matchValue_8 : matchValue_9;
            const this$_70 = item(0, comp.Outputs);
            this$_70.BigIntSlab[(this$_70.StepBase + simStep)] = fd_20;
            break;
        }
        case 22: {
            let matchValue_11;
            const this$_71 = item(0, comp.InputLinks);
            matchValue_11 = (this$_71.UInt32Slab[(this$_71.StepBase + simStep)]);
            let matchValue_12;
            const this$_72 = item(1, comp.InputLinks);
            matchValue_12 = (this$_72.UInt32Slab[(this$_72.StepBase + simStep)]);
            let matchValue_13;
            const this$_73 = item(2, comp.InputLinks);
            matchValue_13 = (this$_73.UInt32Slab[(this$_73.StepBase + simStep)]);
            let matchValue_14;
            const this$_74 = item(3, comp.InputLinks);
            matchValue_14 = (this$_74.UInt32Slab[(this$_74.StepBase + simStep)]);
            let bitSelect_2;
            const this$_75 = item(4, comp.InputLinks);
            bitSelect_2 = (this$_75.UInt32Slab[(this$_75.StepBase + simStep)]);
            const fd_21 = (bitSelect_2 === 0) ? matchValue_11 : ((bitSelect_2 === 1) ? matchValue_12 : ((bitSelect_2 === 2) ? matchValue_13 : ((bitSelect_2 === 3) ? matchValue_14 : toFail(printf("Cannot happen")))));
            const this$_77 = item(0, comp.Outputs);
            this$_77.UInt32Slab[(this$_77.StepBase + simStep)] = fd_21;
            break;
        }
        case 23: {
            let matchValue_16;
            const this$_78 = item(0, comp.InputLinks);
            matchValue_16 = (this$_78.BigIntSlab[(this$_78.StepBase + simStep)]);
            let matchValue_17;
            const this$_79 = item(1, comp.InputLinks);
            matchValue_17 = (this$_79.BigIntSlab[(this$_79.StepBase + simStep)]);
            let matchValue_18;
            const this$_80 = item(2, comp.InputLinks);
            matchValue_18 = (this$_80.BigIntSlab[(this$_80.StepBase + simStep)]);
            let matchValue_19;
            const this$_81 = item(3, comp.InputLinks);
            matchValue_19 = (this$_81.BigIntSlab[(this$_81.StepBase + simStep)]);
            let bitSelect_3;
            const this$_82 = item(4, comp.InputLinks);
            bitSelect_3 = (this$_82.UInt32Slab[(this$_82.StepBase + simStep)]);
            const fd_22 = (bitSelect_3 === 0) ? matchValue_16 : ((bitSelect_3 === 1) ? matchValue_17 : ((bitSelect_3 === 2) ? matchValue_18 : ((bitSelect_3 === 3) ? matchValue_19 : toFail(printf("Cannot happen")))));
            const this$_84 = item(0, comp.Outputs);
            this$_84.BigIntSlab[(this$_84.StepBase + simStep)] = fd_22;
            break;
        }
        case 24: {
            let matchValue_21;
            const this$_85 = item(0, comp.InputLinks);
            matchValue_21 = (this$_85.UInt32Slab[(this$_85.StepBase + simStep)]);
            let matchValue_22;
            const this$_86 = item(1, comp.InputLinks);
            matchValue_22 = (this$_86.UInt32Slab[(this$_86.StepBase + simStep)]);
            let matchValue_23;
            const this$_87 = item(2, comp.InputLinks);
            matchValue_23 = (this$_87.UInt32Slab[(this$_87.StepBase + simStep)]);
            let matchValue_24;
            const this$_88 = item(3, comp.InputLinks);
            matchValue_24 = (this$_88.UInt32Slab[(this$_88.StepBase + simStep)]);
            let matchValue_25;
            const this$_89 = item(4, comp.InputLinks);
            matchValue_25 = (this$_89.UInt32Slab[(this$_89.StepBase + simStep)]);
            let matchValue_26;
            const this$_90 = item(5, comp.InputLinks);
            matchValue_26 = (this$_90.UInt32Slab[(this$_90.StepBase + simStep)]);
            let matchValue_27;
            const this$_91 = item(6, comp.InputLinks);
            matchValue_27 = (this$_91.UInt32Slab[(this$_91.StepBase + simStep)]);
            let matchValue_28;
            const this$_92 = item(7, comp.InputLinks);
            matchValue_28 = (this$_92.UInt32Slab[(this$_92.StepBase + simStep)]);
            let bitSelect_4;
            const this$_93 = item(8, comp.InputLinks);
            bitSelect_4 = (this$_93.UInt32Slab[(this$_93.StepBase + simStep)]);
            const fd_23 = (bitSelect_4 === 0) ? matchValue_21 : ((bitSelect_4 === 1) ? matchValue_22 : ((bitSelect_4 === 2) ? matchValue_23 : ((bitSelect_4 === 3) ? matchValue_24 : ((bitSelect_4 === 4) ? matchValue_25 : ((bitSelect_4 === 5) ? matchValue_26 : ((bitSelect_4 === 6) ? matchValue_27 : ((bitSelect_4 === 7) ? matchValue_28 : toFail(printf("Cannot happen")))))))));
            const this$_95 = item(0, comp.Outputs);
            this$_95.UInt32Slab[(this$_95.StepBase + simStep)] = fd_23;
            break;
        }
        case 25: {
            let matchValue_30;
            const this$_96 = item(0, comp.InputLinks);
            matchValue_30 = (this$_96.BigIntSlab[(this$_96.StepBase + simStep)]);
            let matchValue_31;
            const this$_97 = item(1, comp.InputLinks);
            matchValue_31 = (this$_97.BigIntSlab[(this$_97.StepBase + simStep)]);
            let matchValue_32;
            const this$_98 = item(2, comp.InputLinks);
            matchValue_32 = (this$_98.BigIntSlab[(this$_98.StepBase + simStep)]);
            let matchValue_33;
            const this$_99 = item(3, comp.InputLinks);
            matchValue_33 = (this$_99.BigIntSlab[(this$_99.StepBase + simStep)]);
            let matchValue_34;
            const this$_100 = item(4, comp.InputLinks);
            matchValue_34 = (this$_100.BigIntSlab[(this$_100.StepBase + simStep)]);
            let matchValue_35;
            const this$_101 = item(5, comp.InputLinks);
            matchValue_35 = (this$_101.BigIntSlab[(this$_101.StepBase + simStep)]);
            let matchValue_36;
            const this$_102 = item(6, comp.InputLinks);
            matchValue_36 = (this$_102.BigIntSlab[(this$_102.StepBase + simStep)]);
            let matchValue_37;
            const this$_103 = item(7, comp.InputLinks);
            matchValue_37 = (this$_103.BigIntSlab[(this$_103.StepBase + simStep)]);
            let bitSelect_5;
            const this$_104 = item(8, comp.InputLinks);
            bitSelect_5 = (this$_104.UInt32Slab[(this$_104.StepBase + simStep)]);
            const fd_24 = (bitSelect_5 === 0) ? matchValue_30 : ((bitSelect_5 === 1) ? matchValue_31 : ((bitSelect_5 === 2) ? matchValue_32 : ((bitSelect_5 === 3) ? matchValue_33 : ((bitSelect_5 === 4) ? matchValue_34 : ((bitSelect_5 === 5) ? matchValue_35 : ((bitSelect_5 === 6) ? matchValue_36 : ((bitSelect_5 === 7) ? matchValue_37 : toFail(printf("Cannot happen")))))))));
            const this$_106 = item(0, comp.Outputs);
            this$_106.BigIntSlab[(this$_106.StepBase + simStep)] = fd_24;
            break;
        }
        case 26: {
            let fdIn;
            const this$_107 = item(0, comp.InputLinks);
            fdIn = (this$_107.UInt32Slab[(this$_107.StepBase + simStep)]);
            const patternInput_8 = (((this$_108 = item(1, comp.InputLinks), this$_108.UInt32Slab[(this$_108.StepBase + simStep)])) === 0) ? [fdIn, 0] : [0, fdIn];
            const this$_110 = item(0, comp.Outputs);
            this$_110.UInt32Slab[(this$_110.StepBase + simStep)] = patternInput_8[0];
            const this$_112 = item(1, comp.Outputs);
            this$_112.UInt32Slab[(this$_112.StepBase + simStep)] = patternInput_8[1];
            break;
        }
        case 27: {
            let fdIn_1;
            const this$_113 = item(0, comp.InputLinks);
            fdIn_1 = (this$_113.BigIntSlab[(this$_113.StepBase + simStep)]);
            const patternInput_10 = (((this$_114 = item(1, comp.InputLinks), this$_114.UInt32Slab[(this$_114.StepBase + simStep)])) === 0) ? [fdIn_1, fromZero()] : [fromZero(), fdIn_1];
            const this$_116 = item(0, comp.Outputs);
            this$_116.BigIntSlab[(this$_116.StepBase + simStep)] = patternInput_10[0];
            const this$_118 = item(1, comp.Outputs);
            this$_118.BigIntSlab[(this$_118.StepBase + simStep)] = patternInput_10[1];
            break;
        }
        case 28: {
            let fdIn_2;
            const this$_119 = item(0, comp.InputLinks);
            fdIn_2 = (this$_119.UInt32Slab[(this$_119.StepBase + simStep)]);
            let bitSelect_8;
            const this$_120 = item(1, comp.InputLinks);
            bitSelect_8 = (this$_120.UInt32Slab[(this$_120.StepBase + simStep)]);
            const patternInput_12 = (bitSelect_8 === 0) ? [fdIn_2, 0, 0, 0] : ((bitSelect_8 === 1) ? [0, fdIn_2, 0, 0] : ((bitSelect_8 === 2) ? [0, 0, fdIn_2, 0] : ((bitSelect_8 === 3) ? [0, 0, 0, fdIn_2] : toFail(printf("Cannot happen")))));
            const this$_122 = item(0, comp.Outputs);
            this$_122.UInt32Slab[(this$_122.StepBase + simStep)] = patternInput_12[0];
            const this$_124 = item(1, comp.Outputs);
            this$_124.UInt32Slab[(this$_124.StepBase + simStep)] = patternInput_12[1];
            const this$_126 = item(2, comp.Outputs);
            this$_126.UInt32Slab[(this$_126.StepBase + simStep)] = patternInput_12[2];
            const this$_128 = item(3, comp.Outputs);
            this$_128.UInt32Slab[(this$_128.StepBase + simStep)] = patternInput_12[3];
            break;
        }
        case 29: {
            let fdIn_3;
            const this$_129 = item(0, comp.InputLinks);
            fdIn_3 = (this$_129.BigIntSlab[(this$_129.StepBase + simStep)]);
            let bitSelect_9;
            const this$_130 = item(1, comp.InputLinks);
            bitSelect_9 = (this$_130.UInt32Slab[(this$_130.StepBase + simStep)]);
            const patternInput_14 = (bitSelect_9 === 0) ? [fdIn_3, fromZero(), fromZero(), fromZero()] : ((bitSelect_9 === 1) ? [fromZero(), fdIn_3, fromZero(), fromZero()] : ((bitSelect_9 === 2) ? [fromZero(), fromZero(), fdIn_3, fromZero()] : ((bitSelect_9 === 3) ? [fromZero(), fromZero(), fromZero(), fdIn_3] : toFail(printf("Cannot happen")))));
            const this$_132 = item(0, comp.Outputs);
            this$_132.BigIntSlab[(this$_132.StepBase + simStep)] = patternInput_14[0];
            const this$_134 = item(1, comp.Outputs);
            this$_134.BigIntSlab[(this$_134.StepBase + simStep)] = patternInput_14[1];
            const this$_136 = item(2, comp.Outputs);
            this$_136.BigIntSlab[(this$_136.StepBase + simStep)] = patternInput_14[2];
            const this$_138 = item(3, comp.Outputs);
            this$_138.BigIntSlab[(this$_138.StepBase + simStep)] = patternInput_14[3];
            break;
        }
        case 30: {
            let fdIn_4;
            const this$_139 = item(0, comp.InputLinks);
            fdIn_4 = (this$_139.UInt32Slab[(this$_139.StepBase + simStep)]);
            let bitSelect_10;
            const this$_140 = item(1, comp.InputLinks);
            bitSelect_10 = (this$_140.UInt32Slab[(this$_140.StepBase + simStep)]);
            const patternInput_16 = (bitSelect_10 === 0) ? [fdIn_4, 0, 0, 0, 0, 0, 0, 0] : ((bitSelect_10 === 1) ? [0, fdIn_4, 0, 0, 0, 0, 0, 0] : ((bitSelect_10 === 2) ? [0, 0, fdIn_4, 0, 0, 0, 0, 0] : ((bitSelect_10 === 3) ? [0, 0, 0, fdIn_4, 0, 0, 0, 0] : ((bitSelect_10 === 4) ? [0, 0, 0, 0, fdIn_4, 0, 0, 0] : ((bitSelect_10 === 5) ? [0, 0, 0, 0, 0, fdIn_4, 0, 0] : ((bitSelect_10 === 6) ? [0, 0, 0, 0, 0, 0, fdIn_4, 0] : ((bitSelect_10 === 7) ? [0, 0, 0, 0, 0, 0, 0, fdIn_4] : toFail(printf("Cannot happen")))))))));
            const this$_142 = item(0, comp.Outputs);
            this$_142.UInt32Slab[(this$_142.StepBase + simStep)] = patternInput_16[0];
            const this$_144 = item(1, comp.Outputs);
            this$_144.UInt32Slab[(this$_144.StepBase + simStep)] = patternInput_16[1];
            const this$_146 = item(2, comp.Outputs);
            this$_146.UInt32Slab[(this$_146.StepBase + simStep)] = patternInput_16[2];
            const this$_148 = item(3, comp.Outputs);
            this$_148.UInt32Slab[(this$_148.StepBase + simStep)] = patternInput_16[3];
            const this$_150 = item(4, comp.Outputs);
            this$_150.UInt32Slab[(this$_150.StepBase + simStep)] = patternInput_16[4];
            const this$_152 = item(5, comp.Outputs);
            this$_152.UInt32Slab[(this$_152.StepBase + simStep)] = patternInput_16[5];
            const this$_154 = item(6, comp.Outputs);
            this$_154.UInt32Slab[(this$_154.StepBase + simStep)] = patternInput_16[6];
            const this$_156 = item(7, comp.Outputs);
            this$_156.UInt32Slab[(this$_156.StepBase + simStep)] = patternInput_16[7];
            break;
        }
        case 31: {
            let fdIn_5;
            const this$_157 = item(0, comp.InputLinks);
            fdIn_5 = (this$_157.BigIntSlab[(this$_157.StepBase + simStep)]);
            let bitSelect_11;
            const this$_158 = item(1, comp.InputLinks);
            bitSelect_11 = (this$_158.UInt32Slab[(this$_158.StepBase + simStep)]);
            const patternInput_18 = (bitSelect_11 === 0) ? [fdIn_5, fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fromZero()] : ((bitSelect_11 === 1) ? [fromZero(), fdIn_5, fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fromZero()] : ((bitSelect_11 === 2) ? [fromZero(), fromZero(), fdIn_5, fromZero(), fromZero(), fromZero(), fromZero(), fromZero()] : ((bitSelect_11 === 3) ? [fromZero(), fromZero(), fromZero(), fdIn_5, fromZero(), fromZero(), fromZero(), fromZero()] : ((bitSelect_11 === 4) ? [fromZero(), fromZero(), fromZero(), fromZero(), fdIn_5, fromZero(), fromZero(), fromZero()] : ((bitSelect_11 === 5) ? [fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fdIn_5, fromZero(), fromZero()] : ((bitSelect_11 === 6) ? [fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fdIn_5, fromZero()] : ((bitSelect_11 === 7) ? [fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fromZero(), fdIn_5] : toFail(printf("Cannot happen")))))))));
            const this$_160 = item(0, comp.Outputs);
            this$_160.BigIntSlab[(this$_160.StepBase + simStep)] = patternInput_18[0];
            const this$_162 = item(1, comp.Outputs);
            this$_162.BigIntSlab[(this$_162.StepBase + simStep)] = patternInput_18[1];
            const this$_164 = item(2, comp.Outputs);
            this$_164.BigIntSlab[(this$_164.StepBase + simStep)] = patternInput_18[2];
            const this$_166 = item(3, comp.Outputs);
            this$_166.BigIntSlab[(this$_166.StepBase + simStep)] = patternInput_18[3];
            const this$_168 = item(4, comp.Outputs);
            this$_168.BigIntSlab[(this$_168.StepBase + simStep)] = patternInput_18[4];
            const this$_170 = item(5, comp.Outputs);
            this$_170.BigIntSlab[(this$_170.StepBase + simStep)] = patternInput_18[5];
            const this$_172 = item(6, comp.Outputs);
            this$_172.BigIntSlab[(this$_172.StepBase + simStep)] = patternInput_18[6];
            const this$_174 = item(7, comp.Outputs);
            this$_174.BigIntSlab[(this$_174.StepBase + simStep)] = patternInput_18[7];
            break;
        }
        case 32: {
            let matchValue_51;
            const this$_175 = item(0, comp.InputLinks);
            matchValue_51 = (this$_175.UInt32Slab[(this$_175.StepBase + simStep)]);
            let matchValue_52;
            const this$_176 = item(1, comp.InputLinks);
            matchValue_52 = (this$_176.UInt32Slab[(this$_176.StepBase + simStep)]);
            const cin = matchValue_51;
            let b;
            const this$_177 = item(2, comp.InputLinks);
            b = (this$_177.UInt32Slab[(this$_177.StepBase + simStep)]);
            const a = matchValue_52;
            let patternInput_20;
            const w_6 = item(1, comp.InputLinks).Width | 0;
            const mask = ((1 << w_6) >>> 0) - 1;
            if (w_6 === 32) {
                const sumInt = toUInt64_unchecked(op_Addition(toUInt64_unchecked(op_Addition(toUInt64_unchecked(fromUInt32(a)), toUInt64_unchecked(fromUInt32(b)))), toUInt64_unchecked(fromUInt32((cin & 1) >>> 0))));
                const cout = ((toUInt32_unchecked(toUInt64_unchecked(op_RightShift(sumInt, w_6))) >>> 0) & 1) >>> 0;
                patternInput_20 = [toUInt32_unchecked(sumInt) >>> 0, cout];
            }
            else {
                const sumInt_1 = (((a & mask) >>> 0) + ((b & mask) >>> 0)) + ((cin & 1) >>> 0);
                patternInput_20 = [(sumInt_1 & mask) >>> 0, ((sumInt_1 >>> w_6) & 1) >>> 0];
            }
            const sum_2 = patternInput_20[0];
            if (componentType.tag === 17) {
                const this$_180 = item(0, comp.Outputs);
                this$_180.UInt32Slab[(this$_180.StepBase + simStep)] = sum_2;
                const this$_182 = item(1, comp.Outputs);
                this$_182.UInt32Slab[(this$_182.StepBase + simStep)] = patternInput_20[1];
            }
            else {
                const this$_184 = item(0, comp.Outputs);
                this$_184.UInt32Slab[(this$_184.StepBase + simStep)] = sum_2;
            }
            break;
        }
        case 33: {
            let matchValue_54;
            const this$_185 = item(0, comp.InputLinks);
            matchValue_54 = (this$_185.UInt32Slab[(this$_185.StepBase + simStep)]);
            let matchValue_55;
            const this$_186 = item(1, comp.InputLinks);
            matchValue_55 = (this$_186.BigIntSlab[(this$_186.StepBase + simStep)]);
            let matchValue_56;
            const this$_187 = item(2, comp.InputLinks);
            matchValue_56 = (this$_187.BigIntSlab[(this$_187.StepBase + simStep)]);
            let patternInput_22;
            const w_7 = item(1, comp.InputLinks).Width | 0;
            const mask_1 = bigIntMask(w_7);
            const a_2 = op_BitwiseAnd(matchValue_55, mask_1);
            const b_2 = op_BitwiseAnd(matchValue_56, mask_1);
            const sumInt_2 = (matchValue_54 === 0) ? op_Addition(a_2, b_2) : op_Addition(op_Addition(a_2, b_2), fromOne());
            patternInput_22 = [op_BitwiseAnd(sumInt_2, bigIntMask(w_7)), equals(op_RightShift(sumInt_2, w_7), fromZero()) ? 0 : 1];
            const sum_4 = patternInput_22[0];
            if (componentType.tag === 17) {
                const this$_190 = item(0, comp.Outputs);
                this$_190.BigIntSlab[(this$_190.StepBase + simStep)] = sum_4;
                const this$_192 = item(1, comp.Outputs);
                this$_192.UInt32Slab[(this$_192.StepBase + simStep)] = patternInput_22[1];
            }
            else {
                const this$_194 = item(0, comp.Outputs);
                this$_194.BigIntSlab[(this$_194.StepBase + simStep)] = sum_4;
            }
            break;
        }
        case 34: {
            let matchValue_57;
            const this$_195 = item(0, comp.InputLinks);
            matchValue_57 = (this$_195.UInt32Slab[(this$_195.StepBase + simStep)]);
            let b_3;
            const this$_196 = item(1, comp.InputLinks);
            b_3 = (this$_196.UInt32Slab[(this$_196.StepBase + simStep)]);
            const a_3 = matchValue_57;
            let patternInput_24;
            const w_8 = item(1, comp.InputLinks).Width | 0;
            const mask_2 = ((1 << w_8) >>> 0) - 1;
            if (w_8 === 32) {
                const sumInt_3 = toUInt64_unchecked(op_Addition(toUInt64_unchecked(op_Addition(toUInt64_unchecked(fromUInt32(a_3)), toUInt64_unchecked(fromUInt32(b_3)))), toUInt64_unchecked(fromUInt32((0 & 1) >>> 0))));
                const cout_5 = ((toUInt32_unchecked(toUInt64_unchecked(op_RightShift(sumInt_3, w_8))) >>> 0) & 1) >>> 0;
                patternInput_24 = [toUInt32_unchecked(sumInt_3) >>> 0, cout_5];
            }
            else {
                const sumInt_4 = (((a_3 & mask_2) >>> 0) + ((b_3 & mask_2) >>> 0)) + ((0 & 1) >>> 0);
                patternInput_24 = [(sumInt_4 & mask_2) >>> 0, ((sumInt_4 >>> w_8) & 1) >>> 0];
            }
            const sum_7 = patternInput_24[0];
            if (componentType.tag === 18) {
                const this$_199 = item(0, comp.Outputs);
                this$_199.UInt32Slab[(this$_199.StepBase + simStep)] = sum_7;
                const this$_201 = item(1, comp.Outputs);
                this$_201.UInt32Slab[(this$_201.StepBase + simStep)] = patternInput_24[1];
            }
            else {
                const this$_203 = item(0, comp.Outputs);
                this$_203.UInt32Slab[(this$_203.StepBase + simStep)] = sum_7;
            }
            break;
        }
        case 35: {
            let matchValue_59;
            const this$_204 = item(0, comp.InputLinks);
            matchValue_59 = (this$_204.BigIntSlab[(this$_204.StepBase + simStep)]);
            let matchValue_60;
            const this$_205 = item(1, comp.InputLinks);
            matchValue_60 = (this$_205.BigIntSlab[(this$_205.StepBase + simStep)]);
            let patternInput_26;
            const w_9 = item(1, comp.InputLinks).Width | 0;
            const mask_3 = bigIntMask(w_9);
            const a_5 = op_BitwiseAnd(matchValue_59, mask_3);
            const b_5 = op_BitwiseAnd(matchValue_60, mask_3);
            const sumInt_5 = op_Addition(a_5, b_5);
            patternInput_26 = [op_BitwiseAnd(sumInt_5, bigIntMask(w_9)), equals(op_RightShift(sumInt_5, w_9), fromZero()) ? 0 : 1];
            const sum_9 = patternInput_26[0];
            if (componentType.tag === 18) {
                const this$_208 = item(0, comp.Outputs);
                this$_208.BigIntSlab[(this$_208.StepBase + simStep)] = sum_9;
                const this$_210 = item(1, comp.Outputs);
                this$_210.UInt32Slab[(this$_210.StepBase + simStep)] = patternInput_26[1];
            }
            else {
                const this$_212 = item(0, comp.Outputs);
                this$_212.BigIntSlab[(this$_212.StepBase + simStep)] = sum_9;
            }
            break;
        }
        case 36: {
            let matchValue_61;
            const this$_213 = item(0, comp.InputLinks);
            matchValue_61 = (this$_213.UInt32Slab[(this$_213.StepBase + simStep)]);
            let b_6;
            const this$_214 = item(1, comp.InputLinks);
            b_6 = (this$_214.UInt32Slab[(this$_214.StepBase + simStep)]);
            const a_6 = matchValue_61;
            let fd_65;
            if (op != null) {
                const matchValue_63 = item(0, comp.InputLinks).Width | 0;
                fd_65 = ((matchValue_63 === 32) ? (a_6 * b_6) : (((a_6 * b_6) & (((1 << matchValue_63) >>> 0) - 1)) >>> 0));
            }
            else {
                fd_65 = ((a_6 ^ b_6) >>> 0);
            }
            const this$_217 = item(0, comp.Outputs);
            this$_217.UInt32Slab[(this$_217.StepBase + simStep)] = fd_65;
            break;
        }
        case 37: {
            let matchValue_64;
            const this$_218 = item(0, comp.InputLinks);
            matchValue_64 = (this$_218.BigIntSlab[(this$_218.StepBase + simStep)]);
            let b_7;
            const this$_219 = item(1, comp.InputLinks);
            b_7 = (this$_219.BigIntSlab[(this$_219.StepBase + simStep)]);
            const a_7 = matchValue_64;
            const fd_66 = (op_1 != null) ? op_BitwiseAnd(op_Multiply(a_7, b_7), op_Subtraction(op_LeftShift(fromOne(), item(0, comp.InputLinks).Width), fromOne())) : op_ExclusiveOr(a_7, b_7);
            const this$_222 = item(0, comp.Outputs);
            this$_222.BigIntSlab[(this$_222.StepBase + simStep)] = fd_66;
            break;
        }
        case 38: {
            const fd_67 = (((this$_223 = item(0, comp.InputLinks), this$_223.UInt32Slab[(this$_223.StepBase + simStep)])) | ((this$_224 = item(1, comp.InputLinks), this$_224.UInt32Slab[(this$_224.StepBase + simStep)]))) >>> 0;
            const this$_226 = item(0, comp.Outputs);
            this$_226.UInt32Slab[(this$_226.StepBase + simStep)] = fd_67;
            break;
        }
        case 39: {
            const fd_68 = op_BitwiseOr((this$_227 = item(0, comp.InputLinks), this$_227.BigIntSlab[(this$_227.StepBase + simStep)]), (this$_228 = item(1, comp.InputLinks), this$_228.BigIntSlab[(this$_228.StepBase + simStep)]));
            const this$_230 = item(0, comp.Outputs);
            this$_230.BigIntSlab[(this$_230.StepBase + simStep)] = fd_68;
            break;
        }
        case 40: {
            const fd_69 = (((this$_231 = item(0, comp.InputLinks), this$_231.UInt32Slab[(this$_231.StepBase + simStep)])) & ((this$_232 = item(1, comp.InputLinks), this$_232.UInt32Slab[(this$_232.StepBase + simStep)]))) >>> 0;
            const this$_234 = item(0, comp.Outputs);
            this$_234.UInt32Slab[(this$_234.StepBase + simStep)] = fd_69;
            break;
        }
        case 41: {
            const fd_70 = op_BitwiseAnd((this$_235 = item(0, comp.InputLinks), this$_235.BigIntSlab[(this$_235.StepBase + simStep)]), (this$_236 = item(1, comp.InputLinks), this$_236.BigIntSlab[(this$_236.StepBase + simStep)]));
            const this$_238 = item(0, comp.Outputs);
            this$_238.BigIntSlab[(this$_238.StepBase + simStep)] = fd_70;
            break;
        }
        case 42: {
            let a_12;
            const this$_239 = item(0, comp.InputLinks);
            a_12 = (this$_239.UInt32Slab[(this$_239.StepBase + simStep)]);
            const w_11 = item(0, comp.InputLinks).Width | 0;
            const fd_71 = (w_11 === 32) ? (~a_12 >>> 0) : (((((1 << w_11) >>> 0) - 1) & (~a_12 >>> 0)) >>> 0);
            const this$_242 = item(0, comp.Outputs);
            this$_242.UInt32Slab[(this$_242.StepBase + simStep)] = fd_71;
            break;
        }
        case 43: {
            let a_13;
            const this$_243 = item(0, comp.InputLinks);
            a_13 = (this$_243.BigIntSlab[(this$_243.StepBase + simStep)]);
            const w_12 = item(0, comp.InputLinks).Width | 0;
            const mask_4 = op_Subtraction(op_LeftShift(fromOne(), w_12), fromOne());
            const fd_72 = op_Subtraction(mask_4, op_BitwiseAnd(a_13, mask_4));
            const this$_246 = item(0, comp.Outputs);
            this$_246.BigIntSlab[(this$_246.StepBase + simStep)] = fd_72;
            break;
        }
        case 44: {
            let a_14;
            const this$_247 = item(0, comp.InputLinks);
            a_14 = (this$_247.UInt32Slab[(this$_247.StepBase + simStep)]);
            const fd_73 = (a_14 === 0) ? 0 : ((a_14 === 1) ? ((numberOfBits_12 !== 32) ? (((1 << numberOfBits_12) >>> 0) - 1) : 4294967295) : toFail(printf("Can\'t happen")));
            const this$_249 = item(0, comp.Outputs);
            this$_249.UInt32Slab[(this$_249.StepBase + simStep)] = fd_73;
            break;
        }
        case 45: {
            let a_15;
            const this$_250 = item(0, comp.InputLinks);
            a_15 = (this$_250.UInt32Slab[(this$_250.StepBase + simStep)]);
            const fd_74 = (a_15 === 0) ? fromZero() : ((a_15 === 1) ? op_Subtraction(op_LeftShift(fromOne(), numberOfBits_13), fromOne()) : toFail(printf("Can\'t happen")));
            const this$_252 = item(0, comp.Outputs);
            this$_252.BigIntSlab[(this$_252.StepBase + simStep)] = fd_74;
            break;
        }
        case 46: {
            const mask_5 = (width_18 === 32) ? 4294967295 : (((1 << width_18) >>> 0) - 1);
            const bits_12 = (((this$_253 = item(0, comp.InputLinks), this$_253.UInt32Slab[(this$_253.StepBase + simStep)])) & mask_5) >>> 0;
            let amt;
            const this$_254 = item(1, comp.InputLinks);
            amt = (this$_254.UInt32Slab[(this$_254.StepBase + simStep)]);
            const signSet = (((bits_12 >>> (width_18 - 1)) & 1) >>> 0) === 1;
            let fd_75;
            if (amt === 0) {
                fd_75 = bits_12;
            }
            else if (amt >= (width_18 >>> 0)) {
                switch (shiftType.tag) {
                    case 2: {
                        fd_75 = (signSet ? mask_5 : 0);
                        break;
                    }
                    default:
                        fd_75 = 0;
                }
            }
            else {
                const amt_1 = ~~amt | 0;
                fd_75 = ((shiftType.tag === 1) ? (bits_12 >>> amt_1) : ((shiftType.tag === 2) ? (signSet ? (((bits_12 >>> amt_1) | ((mask_5 & ((mask_5 << (width_18 - amt_1)) >>> 0)) >>> 0)) >>> 0) : (bits_12 >>> amt_1)) : ((((bits_12 << amt_1) >>> 0) & mask_5) >>> 0)));
            }
            const this$_256 = item(0, comp.Outputs);
            this$_256.UInt32Slab[(this$_256.StepBase + simStep)] = fd_75;
            break;
        }
        case 47: {
            const mask_6 = bigIntMask(width_19);
            const bits_13 = op_BitwiseAnd((this$_257 = item(0, comp.InputLinks), this$_257.BigIntSlab[(this$_257.StepBase + simStep)]), mask_6);
            let amt_2;
            const this$_258 = item(1, comp.InputLinks);
            amt_2 = (this$_258.UInt32Slab[(this$_258.StepBase + simStep)]);
            const signSet_1 = equals(op_BitwiseAnd(op_RightShift(bits_13, width_19 - 1), fromOne()), fromOne());
            let fd_76;
            if (amt_2 >= (width_19 >>> 0)) {
                switch (shiftType_1.tag) {
                    case 2: {
                        fd_76 = (signSet_1 ? mask_6 : fromZero());
                        break;
                    }
                    default:
                        fd_76 = fromZero();
                }
            }
            else {
                const amt_3 = ~~amt_2 | 0;
                fd_76 = ((shiftType_1.tag === 1) ? op_RightShift(bits_13, amt_3) : ((shiftType_1.tag === 2) ? (signSet_1 ? op_BitwiseOr(op_RightShift(bits_13, amt_3), op_BitwiseAnd(mask_6, op_LeftShift(mask_6, width_19 - amt_3))) : op_RightShift(bits_13, amt_3)) : op_BitwiseAnd(op_LeftShift(bits_13, amt_3), mask_6)));
            }
            const this$_260 = item(0, comp.Outputs);
            this$_260.BigIntSlab[(this$_260.StepBase + simStep)] = fd_76;
            break;
        }
        case 48: {
            toFail(printf("what? Custom components are removed before the fast simulation: %A"))(c);
            break;
        }
        case 49: {
            let matchValue_74;
            const this$_261 = item(0, comp.InputLinks);
            matchValue_74 = (this$_261.UInt32Slab[(this$_261.StepBase + simStep)]);
            const fd_77 = (((((this$_262 = item(1, comp.InputLinks), this$_262.UInt32Slab[(this$_262.StepBase + simStep)])) << item(0, comp.InputLinks).Width) >>> 0) | matchValue_74) >>> 0;
            const this$_265 = item(0, comp.Outputs);
            this$_265.UInt32Slab[(this$_265.StepBase + simStep)] = fd_77;
            break;
        }
        case 50: {
            const matchValue_76 = comp.BigIntState;
            if (matchValue_76 != null) {
                matchValue_76.OutputIsBigInt;
                const ins = matchValue_76.InputIsBigInt;
                const matchValue_77 = item(0, ins);
                const matchValue_78 = item(1, ins);
                if (matchValue_77) {
                    if (matchValue_78) {
                        let matchValue_86;
                        const this$_281 = item(0, comp.InputLinks);
                        matchValue_86 = (this$_281.BigIntSlab[(this$_281.StepBase + simStep)]);
                        const fd_81 = op_BitwiseOr(op_LeftShift((this$_282 = item(1, comp.InputLinks), this$_282.BigIntSlab[(this$_282.StepBase + simStep)]), item(0, comp.InputLinks).Width), matchValue_86);
                        const this$_285 = item(0, comp.Outputs);
                        this$_285.BigIntSlab[(this$_285.StepBase + simStep)] = fd_81;
                    }
                    else {
                        let matchValue_84;
                        const this$_276 = item(0, comp.InputLinks);
                        matchValue_84 = (this$_276.BigIntSlab[(this$_276.StepBase + simStep)]);
                        const fd_80 = op_BitwiseOr(op_LeftShift(fromUInt32((this$_277 = item(1, comp.InputLinks), this$_277.UInt32Slab[(this$_277.StepBase + simStep)])), item(0, comp.InputLinks).Width), matchValue_84);
                        const this$_280 = item(0, comp.Outputs);
                        this$_280.BigIntSlab[(this$_280.StepBase + simStep)] = fd_80;
                    }
                }
                else if (matchValue_78) {
                    let matchValue_82;
                    const this$_271 = item(0, comp.InputLinks);
                    matchValue_82 = (this$_271.UInt32Slab[(this$_271.StepBase + simStep)]);
                    const fd_79 = op_BitwiseOr(op_LeftShift((this$_272 = item(1, comp.InputLinks), this$_272.BigIntSlab[(this$_272.StepBase + simStep)]), item(0, comp.InputLinks).Width), fromUInt32(matchValue_82));
                    const this$_275 = item(0, comp.Outputs);
                    this$_275.BigIntSlab[(this$_275.StepBase + simStep)] = fd_79;
                }
                else {
                    let matchValue_80;
                    const this$_266 = item(0, comp.InputLinks);
                    matchValue_80 = (this$_266.UInt32Slab[(this$_266.StepBase + simStep)]);
                    const fd_78 = op_BitwiseOr(op_LeftShift(fromUInt32((this$_267 = item(1, comp.InputLinks), this$_267.UInt32Slab[(this$_267.StepBase + simStep)])), item(0, comp.InputLinks).Width), fromUInt32(matchValue_80));
                    const this$_270 = item(0, comp.Outputs);
                    this$_270.BigIntSlab[(this$_270.StepBase + simStep)] = fd_78;
                }
            }
            else {
                throw new Exception("MergeWires with BigIntState");
            }
            break;
        }
        case 51: {
            let res_17 = 0;
            for (let i_206 = n_102 - 1; i_206 >= 0; i_206--) {
                let this$_287;
                res_17 = ((((res_17 << item(i_206, comp.InputLinks).Width) >>> 0) | ((this$_287 = item(i_206, comp.InputLinks), this$_287.UInt32Slab[(this$_287.StepBase + simStep)]))) >>> 0);
            }
            const fd_82 = res_17;
            const this$_289 = item(0, comp.Outputs);
            this$_289.UInt32Slab[(this$_289.StepBase + simStep)] = fd_82;
            break;
        }
        case 52: {
            const matchValue_88 = comp.BigIntState;
            if (matchValue_88 != null) {
                matchValue_88.OutputIsBigInt;
                const ins_1 = matchValue_88.InputIsBigInt;
                let res_18 = fromZero();
                for (let i_209 = n_105 - 1; i_209 >= 0; i_209--) {
                    let this$_291;
                    let input;
                    if (item(i_209, ins_1)) {
                        const this$_290 = item(i_209, comp.InputLinks);
                        input = (this$_290.BigIntSlab[(this$_290.StepBase + simStep)]);
                    }
                    else {
                        input = fromUInt32((this$_291 = item(i_209, comp.InputLinks), this$_291.UInt32Slab[(this$_291.StepBase + simStep)]));
                    }
                    res_18 = op_BitwiseOr(op_LeftShift(res_18, item(i_209, comp.InputLinks).Width), input);
                }
                const fd_83 = res_18;
                const this$_294 = item(0, comp.Outputs);
                this$_294.BigIntSlab[(this$_294.StepBase + simStep)] = fd_83;
            }
            else {
                throw new Exception("MergeN with BigIntState");
            }
            break;
        }
        case 53: {
            const w_13 = item(0, comp.InputLinks).Width | 0;
            let res_19 = 0;
            for (let i_214 = n_108 - 1; i_214 >= 0; i_214--) {
                let this$_296;
                res_19 = ((((res_19 << w_13) >>> 0) | ((this$_296 = item(i_214, comp.InputLinks), this$_296.UInt32Slab[(this$_296.StepBase + simStep)]))) >>> 0);
            }
            const fd_84 = res_19;
            const this$_298 = item(0, comp.Outputs);
            this$_298.UInt32Slab[(this$_298.StepBase + simStep)] = fd_84;
            break;
        }
        case 54: {
            const matchValue_89 = comp.BigIntState;
            if (matchValue_89 != null) {
                const ins_2 = matchValue_89.InputIsBigInt;
                const w_14 = item(0, comp.InputLinks).Width | 0;
                let res_20 = fromZero();
                for (let i_217 = n_111 - 1; i_217 >= 0; i_217--) {
                    let this$_301;
                    let input_1;
                    if (item(i_217, ins_2)) {
                        const this$_300 = item(i_217, comp.InputLinks);
                        input_1 = (this$_300.BigIntSlab[(this$_300.StepBase + simStep)]);
                    }
                    else {
                        input_1 = fromUInt32((this$_301 = item(i_217, comp.InputLinks), this$_301.UInt32Slab[(this$_301.StepBase + simStep)]));
                    }
                    res_20 = op_BitwiseOr(op_LeftShift(res_20, w_14), input_1);
                }
                const fd_85 = res_20;
                const this$_303 = item(0, comp.Outputs);
                this$_303.BigIntSlab[(this$_303.StepBase + simStep)] = fd_85;
            }
            else {
                throw new Exception("ArrayMerge with BigIntState");
            }
            break;
        }
        case 55: {
            const sel = ~~((this$_304 = item(n_114, comp.InputLinks), this$_304.UInt32Slab[(this$_304.StepBase + simStep)])) | 0;
            let fd_86;
            if ((sel >= 0) && (sel < n_114)) {
                const this$_307 = item(sel, comp.InputLinks);
                fd_86 = (this$_307.UInt32Slab[(this$_307.StepBase + simStep)]);
            }
            else {
                fd_86 = 0;
            }
            const this$_306 = item(0, comp.Outputs);
            this$_306.UInt32Slab[(this$_306.StepBase + simStep)] = fd_86;
            break;
        }
        case 56: {
            const matchValue_90 = comp.BigIntState;
            if (matchValue_90 != null) {
                const ins_3 = matchValue_90.InputIsBigInt;
                const sel_1 = ~~((this$_308 = item(n_116, comp.InputLinks), this$_308.UInt32Slab[(this$_308.StepBase + simStep)])) | 0;
                let fd_87;
                if ((sel_1 >= 0) && (sel_1 < n_116)) {
                    if (item(sel_1, ins_3)) {
                        const this$_309 = item(sel_1, comp.InputLinks);
                        fd_87 = (this$_309.BigIntSlab[(this$_309.StepBase + simStep)]);
                    }
                    else {
                        fd_87 = fromUInt32((this$_310 = item(sel_1, comp.InputLinks), this$_310.UInt32Slab[(this$_310.StepBase + simStep)]));
                    }
                }
                else {
                    fd_87 = fromZero();
                }
                const this$_312 = item(0, comp.Outputs);
                this$_312.BigIntSlab[(this$_312.StepBase + simStep)] = fd_87;
            }
            else {
                throw new Exception("ArrayMux with BigIntState");
            }
            break;
        }
        case 57: {
            let bits_14;
            const this$_313 = item(0, comp.InputLinks);
            bits_14 = (this$_313.UInt32Slab[(this$_313.StepBase + simStep)]);
            let patternInput_38;
            const bits1_11 = getBitsFromUInt32(item(0, comp.InputLinks).Width - 1, topWireWidth, bits_14);
            patternInput_38 = [getBitsFromUInt32(topWireWidth - 1, 0, bits_14), bits1_11];
            const this$_316 = item(0, comp.Outputs);
            this$_316.UInt32Slab[(this$_316.StepBase + simStep)] = patternInput_38[0];
            const this$_318 = item(1, comp.Outputs);
            this$_318.UInt32Slab[(this$_318.StepBase + simStep)] = patternInput_38[1];
            break;
        }
        case 58: {
            let bits_15;
            const this$_319 = item(0, comp.InputLinks);
            bits_15 = (this$_319.UInt32Slab[(this$_319.StepBase + simStep)]);
            iterateIndexed2((index, width_20, lsb_2) => {
                const fd_90 = getBitsFromUInt32((width_20 + lsb_2) - 1, lsb_2, bits_15);
                const this$_321 = item(index, comp.Outputs);
                this$_321.UInt32Slab[(this$_321.StepBase + simStep)] = fd_90;
            }, outputWidths, lsBits);
            break;
        }
        case 59: {
            const matchValue_91 = comp.BigIntState;
            if (matchValue_91 != null) {
                const outs_3 = matchValue_91.OutputIsBigInt;
                matchValue_91.InputIsBigInt;
                let bits_16;
                const this$_322 = item(0, comp.InputLinks);
                bits_16 = (this$_322.BigIntSlab[(this$_322.StepBase + simStep)]);
                iterateIndexed2((index_1, width_21, lsb_3) => {
                    const msb = ((width_21 + lsb_3) - 1) | 0;
                    if (item(index_1, outs_3)) {
                        const fd_91 = getBitsFromBigInt(msb, lsb_3, bits_16);
                        const this$_324 = item(index_1, comp.Outputs);
                        this$_324.BigIntSlab[(this$_324.StepBase + simStep)] = fd_91;
                    }
                    else {
                        const fd_92 = getBitsFromBigIntToUInt32(msb, lsb_3, bits_16);
                        const this$_326 = item(index_1, comp.Outputs);
                        this$_326.UInt32Slab[(this$_326.StepBase + simStep)] = fd_92;
                    }
                }, outputWidths_1, lsBits_1);
            }
            else {
                throw new Exception("SplitN with BigIntState");
            }
            break;
        }
        case 60: {
            let bits_17;
            const this$_327 = item(0, comp.InputLinks);
            bits_17 = (this$_327.BigIntSlab[(this$_327.StepBase + simStep)]);
            const matchValue_92 = comp.BigIntState;
            if (matchValue_92 != null) {
                const outs_4 = matchValue_92.OutputIsBigInt;
                const matchValue_93 = item(0, outs_4);
                const matchValue_94 = item(1, outs_4);
                if (matchValue_93) {
                    if (matchValue_94) {
                        const bits0_16 = getBitsFromBigInt(topWireWidth_1 - 1, 0, bits_17);
                        const bits1_16 = getBitsFromBigInt(item(0, comp.InputLinks).Width - 1, topWireWidth_1, bits_17);
                        const this$_345 = item(0, comp.Outputs);
                        this$_345.BigIntSlab[(this$_345.StepBase + simStep)] = bits0_16;
                        const this$_347 = item(1, comp.Outputs);
                        this$_347.BigIntSlab[(this$_347.StepBase + simStep)] = bits1_16;
                    }
                    else {
                        const bits0_15 = getBitsFromBigInt(topWireWidth_1 - 1, 0, bits_17);
                        const bits1_15 = getBitsFromBigIntToUInt32(item(0, comp.InputLinks).Width - 1, topWireWidth_1, bits_17);
                        const this$_340 = item(0, comp.Outputs);
                        this$_340.BigIntSlab[(this$_340.StepBase + simStep)] = bits0_15;
                        const this$_342 = item(1, comp.Outputs);
                        this$_342.UInt32Slab[(this$_342.StepBase + simStep)] = bits1_15;
                    }
                }
                else if (matchValue_94) {
                    const bits0_14 = getBitsFromBigIntToUInt32(topWireWidth_1 - 1, 0, bits_17);
                    const bits1_14 = getBitsFromBigInt(item(0, comp.InputLinks).Width - 1, topWireWidth_1, bits_17);
                    const this$_335 = item(0, comp.Outputs);
                    this$_335.UInt32Slab[(this$_335.StepBase + simStep)] = bits0_14;
                    const this$_337 = item(1, comp.Outputs);
                    this$_337.BigIntSlab[(this$_337.StepBase + simStep)] = bits1_14;
                }
                else {
                    const bits0_13 = getBitsFromBigIntToUInt32(topWireWidth_1 - 1, 0, bits_17);
                    const bits1_13 = getBitsFromBigIntToUInt32(item(0, comp.InputLinks).Width - 1, topWireWidth_1, bits_17);
                    const this$_330 = item(0, comp.Outputs);
                    this$_330.UInt32Slab[(this$_330.StepBase + simStep)] = bits0_13;
                    const this$_332 = item(1, comp.Outputs);
                    this$_332.UInt32Slab[(this$_332.StepBase + simStep)] = bits1_13;
                }
            }
            else {
                throw new Exception("SplitWire with BigIntState");
            }
            break;
        }
        case 61: {
            let fd_101;
            if (numStep === 0) {
                fd_101 = 0;
            }
            else {
                const this$_349 = item(0, comp.InputLinks);
                fd_101 = (this$_349.UInt32Slab[(this$_349.StepBase + simStepOld)]);
            }
            const this$_351 = item(0, comp.Outputs);
            this$_351.UInt32Slab[(this$_351.StepBase + simStep)] = fd_101;
            break;
        }
        case 62: {
            let matchValue_96;
            if (numStep === 0) {
                matchValue_96 = 0;
            }
            else {
                const this$_353 = item(0, comp.InputLinks);
                matchValue_96 = (this$_353.UInt32Slab[(this$_353.StepBase + simStepOld)]);
            }
            let en;
            if (numStep === 0) {
                en = 0;
            }
            else {
                const this$_355 = item(1, comp.InputLinks);
                en = (this$_355.UInt32Slab[(this$_355.StepBase + simStepOld)]);
            }
            switch (en) {
                case 0: {
                    let fd_102;
                    if (numStep === 0) {
                        fd_102 = 0;
                    }
                    else {
                        const this$_358 = item(0, comp.Outputs);
                        fd_102 = (this$_358.UInt32Slab[(this$_358.StepBase + simStepOld)]);
                    }
                    const this$_357 = item(0, comp.Outputs);
                    this$_357.UInt32Slab[(this$_357.StepBase + simStep)] = fd_102;
                    break;
                }
                case 1: {
                    const this$_360 = item(0, comp.Outputs);
                    this$_360.UInt32Slab[(this$_360.StepBase + simStep)] = matchValue_96;
                    break;
                }
                default:
                    throw new Exception("Can\'t happen");
            }
            break;
        }
        case 63: {
            toFail(printf("DFF/DFFE with BigIntState"));
            break;
        }
        case 64: {
            let fd_104;
            if (numStep === 0) {
                fd_104 = 0;
            }
            else {
                const this$_362 = item(0, comp.InputLinks);
                fd_104 = (this$_362.UInt32Slab[(this$_362.StepBase + simStepOld)]);
            }
            const this$_364 = item(0, comp.Outputs);
            this$_364.UInt32Slab[(this$_364.StepBase + simStep)] = fd_104;
            break;
        }
        case 65: {
            let fd_105;
            if (numStep === 0) {
                fd_105 = fromZero();
            }
            else {
                const this$_366 = item(0, comp.InputLinks);
                fd_105 = (this$_366.BigIntSlab[(this$_366.StepBase + simStepOld)]);
            }
            const this$_368 = item(0, comp.Outputs);
            this$_368.BigIntSlab[(this$_368.StepBase + simStep)] = fd_105;
            break;
        }
        case 66: {
            let matchValue_98;
            if (numStep === 0) {
                matchValue_98 = 0;
            }
            else {
                const this$_370 = item(0, comp.InputLinks);
                matchValue_98 = (this$_370.UInt32Slab[(this$_370.StepBase + simStepOld)]);
            }
            let enable;
            if (numStep === 0) {
                enable = 0;
            }
            else {
                const this$_372 = item(1, comp.InputLinks);
                enable = (this$_372.UInt32Slab[(this$_372.StepBase + simStepOld)]);
            }
            switch (enable) {
                case 0: {
                    let fd_106;
                    if (numStep === 0) {
                        fd_106 = 0;
                    }
                    else {
                        const this$_375 = item(0, comp.Outputs);
                        fd_106 = (this$_375.UInt32Slab[(this$_375.StepBase + simStepOld)]);
                    }
                    const this$_374 = item(0, comp.Outputs);
                    this$_374.UInt32Slab[(this$_374.StepBase + simStep)] = fd_106;
                    break;
                }
                case 1: {
                    const this$_377 = item(0, comp.Outputs);
                    this$_377.UInt32Slab[(this$_377.StepBase + simStep)] = matchValue_98;
                    break;
                }
                default:
                    toFail(printf("RegisterE received invalid enable value: %A"))(enable);
            }
            break;
        }
        case 67: {
            let matchValue_100;
            if (numStep === 0) {
                matchValue_100 = fromZero();
            }
            else {
                const this$_379 = item(0, comp.InputLinks);
                matchValue_100 = (this$_379.BigIntSlab[(this$_379.StepBase + simStepOld)]);
            }
            let enable_1;
            if (numStep === 0) {
                enable_1 = 0;
            }
            else {
                const this$_381 = item(1, comp.InputLinks);
                enable_1 = (this$_381.UInt32Slab[(this$_381.StepBase + simStepOld)]);
            }
            switch (enable_1) {
                case 0: {
                    let fd_108;
                    if (numStep === 0) {
                        fd_108 = fromZero();
                    }
                    else {
                        const this$_384 = item(0, comp.Outputs);
                        fd_108 = (this$_384.BigIntSlab[(this$_384.StepBase + simStepOld)]);
                    }
                    const this$_383 = item(0, comp.Outputs);
                    this$_383.BigIntSlab[(this$_383.StepBase + simStep)] = fd_108;
                    break;
                }
                case 1: {
                    const this$_386 = item(0, comp.Outputs);
                    this$_386.BigIntSlab[(this$_386.StepBase + simStep)] = matchValue_100;
                    break;
                }
                default:
                    toFail(printf("RegisterE received invalid enable value: %A"))(enable_1);
            }
            break;
        }
        case 68: {
            let matchValue_102;
            if (numStep === 0) {
                matchValue_102 = 0;
            }
            else {
                const this$_388 = item(0, comp.InputLinks);
                matchValue_102 = (this$_388.UInt32Slab[(this$_388.StepBase + simStepOld)]);
            }
            let matchValue_103;
            if (numStep === 0) {
                matchValue_103 = 0;
            }
            else {
                const this$_390 = item(1, comp.InputLinks);
                matchValue_103 = (this$_390.UInt32Slab[(this$_390.StepBase + simStepOld)]);
            }
            let matchValue_104;
            if (numStep === 0) {
                matchValue_104 = 0;
            }
            else {
                const this$_392 = item(2, comp.InputLinks);
                matchValue_104 = (this$_392.UInt32Slab[(this$_392.StepBase + simStepOld)]);
            }
            const load = matchValue_103;
            let fd_110;
            let matchResult_1;
            if (matchValue_104 === 1) {
                switch (load) {
                    case 0: {
                        matchResult_1 = 0;
                        break;
                    }
                    case 1: {
                        matchResult_1 = 1;
                        break;
                    }
                    default:
                        matchResult_1 = 2;
                }
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0: {
                    const width_27 = width_26 | 0;
                    const next = ((numStep === 0) ? 0 : ((this$_393 = item(0, comp.Outputs), this$_393.UInt32Slab[(this$_393.StepBase + simStepOld)]))) + 1;
                    fd_110 = (((width_27 < 32) && (next === ((1 << width_27) >>> 0))) ? 0 : next);
                    break;
                }
                case 1: {
                    fd_110 = matchValue_102;
                    break;
                }
                default: {
                    if (numStep === 0) {
                        fd_110 = 0;
                    }
                    else {
                        const this$_394 = item(0, comp.Outputs);
                        fd_110 = (this$_394.UInt32Slab[(this$_394.StepBase + simStepOld)]);
                    }
                }
            }
            const this$_396 = item(0, comp.Outputs);
            this$_396.UInt32Slab[(this$_396.StepBase + simStep)] = fd_110;
            break;
        }
        case 69: {
            let matchValue_106;
            if (numStep === 0) {
                matchValue_106 = fromZero();
            }
            else {
                const this$_398 = item(0, comp.InputLinks);
                matchValue_106 = (this$_398.BigIntSlab[(this$_398.StepBase + simStepOld)]);
            }
            let matchValue_107;
            if (numStep === 0) {
                matchValue_107 = 0;
            }
            else {
                const this$_400 = item(1, comp.InputLinks);
                matchValue_107 = (this$_400.UInt32Slab[(this$_400.StepBase + simStepOld)]);
            }
            let matchValue_108;
            if (numStep === 0) {
                matchValue_108 = 0;
            }
            else {
                const this$_402 = item(2, comp.InputLinks);
                matchValue_108 = (this$_402.UInt32Slab[(this$_402.StepBase + simStepOld)]);
            }
            const load_1 = matchValue_107;
            let fd_111;
            let matchResult_2;
            if (matchValue_108 === 1) {
                switch (load_1) {
                    case 0: {
                        matchResult_2 = 0;
                        break;
                    }
                    case 1: {
                        matchResult_2 = 1;
                        break;
                    }
                    default:
                        matchResult_2 = 2;
                }
            }
            else {
                matchResult_2 = 2;
            }
            switch (matchResult_2) {
                case 0: {
                    const n_169 = op_Addition((numStep === 0) ? fromZero() : ((this$_403 = item(0, comp.Outputs), this$_403.BigIntSlab[(this$_403.StepBase + simStepOld)])), fromOne());
                    fd_111 = (equals(n_169, op_LeftShift(fromOne(), width_28)) ? fromZero() : n_169);
                    break;
                }
                case 1: {
                    fd_111 = matchValue_106;
                    break;
                }
                default: {
                    if (numStep === 0) {
                        fd_111 = fromZero();
                    }
                    else {
                        const this$_404 = item(0, comp.Outputs);
                        fd_111 = (this$_404.BigIntSlab[(this$_404.StepBase + simStepOld)]);
                    }
                }
            }
            const this$_406 = item(0, comp.Outputs);
            this$_406.BigIntSlab[(this$_406.StepBase + simStep)] = fd_111;
            break;
        }
        case 70: {
            let matchValue_110;
            if (numStep === 0) {
                matchValue_110 = 0;
            }
            else {
                const this$_408 = item(0, comp.InputLinks);
                matchValue_110 = (this$_408.UInt32Slab[(this$_408.StepBase + simStepOld)]);
            }
            let load_2;
            if (numStep === 0) {
                load_2 = 0;
            }
            else {
                const this$_410 = item(1, comp.InputLinks);
                load_2 = (this$_410.UInt32Slab[(this$_410.StepBase + simStepOld)]);
            }
            let fd_112;
            switch (load_2) {
                case 0: {
                    const width_30 = width_29 | 0;
                    const next_1 = ((numStep === 0) ? 0 : ((this$_411 = item(0, comp.Outputs), this$_411.UInt32Slab[(this$_411.StepBase + simStepOld)]))) + 1;
                    fd_112 = (((width_30 < 32) && (next_1 === ((1 << width_30) >>> 0))) ? 0 : next_1);
                    break;
                }
                case 1: {
                    fd_112 = matchValue_110;
                    break;
                }
                default:
                    fd_112 = toFail(printf("CounterNoEnable received invalid load value: %A"))(load_2);
            }
            const this$_413 = item(0, comp.Outputs);
            this$_413.UInt32Slab[(this$_413.StepBase + simStep)] = fd_112;
            break;
        }
        case 71: {
            let matchValue_112;
            if (numStep === 0) {
                matchValue_112 = fromZero();
            }
            else {
                const this$_415 = item(0, comp.InputLinks);
                matchValue_112 = (this$_415.BigIntSlab[(this$_415.StepBase + simStepOld)]);
            }
            let load_3;
            if (numStep === 0) {
                load_3 = 0;
            }
            else {
                const this$_417 = item(1, comp.InputLinks);
                load_3 = (this$_417.UInt32Slab[(this$_417.StepBase + simStepOld)]);
            }
            let fd_113;
            switch (load_3) {
                case 0: {
                    const n_179 = op_Addition((numStep === 0) ? fromZero() : ((this$_418 = item(0, comp.Outputs), this$_418.BigIntSlab[(this$_418.StepBase + simStepOld)])), fromOne());
                    fd_113 = (equals(n_179, op_LeftShift(fromOne(), width_31)) ? fromZero() : n_179);
                    break;
                }
                case 1: {
                    fd_113 = matchValue_112;
                    break;
                }
                default:
                    fd_113 = toFail(printf("CounterNoEnable received invalid load value: %A"))(load_3);
            }
            const this$_420 = item(0, comp.Outputs);
            this$_420.BigIntSlab[(this$_420.StepBase + simStep)] = fd_113;
            break;
        }
        case 72: {
            let enable_4;
            if (numStep === 0) {
                enable_4 = 0;
            }
            else {
                const this$_422 = item(0, comp.InputLinks);
                enable_4 = (this$_422.UInt32Slab[(this$_422.StepBase + simStepOld)]);
            }
            let fd_114;
            switch (enable_4) {
                case 0: {
                    if (numStep === 0) {
                        fd_114 = 0;
                    }
                    else {
                        const this$_424 = item(0, comp.Outputs);
                        fd_114 = (this$_424.UInt32Slab[(this$_424.StepBase + simStepOld)]);
                    }
                    break;
                }
                case 1: {
                    const width_33 = width_32 | 0;
                    const next_2 = ((numStep === 0) ? 0 : ((this$_423 = item(0, comp.Outputs), this$_423.UInt32Slab[(this$_423.StepBase + simStepOld)]))) + 1;
                    fd_114 = (((width_33 < 32) && (next_2 === ((1 << width_33) >>> 0))) ? 0 : next_2);
                    break;
                }
                default:
                    fd_114 = toFail(printf("CounterNoLoad received invalid enable value: %A"))(enable_4);
            }
            const this$_426 = item(0, comp.Outputs);
            this$_426.UInt32Slab[(this$_426.StepBase + simStep)] = fd_114;
            break;
        }
        case 73: {
            let enable_5;
            if (numStep === 0) {
                enable_5 = 0;
            }
            else {
                const this$_428 = item(0, comp.InputLinks);
                enable_5 = (this$_428.UInt32Slab[(this$_428.StepBase + simStepOld)]);
            }
            let fd_115;
            switch (enable_5) {
                case 0: {
                    if (numStep === 0) {
                        fd_115 = fromZero();
                    }
                    else {
                        const this$_430 = item(0, comp.Outputs);
                        fd_115 = (this$_430.BigIntSlab[(this$_430.StepBase + simStepOld)]);
                    }
                    break;
                }
                case 1: {
                    const n_187 = op_Addition((numStep === 0) ? fromZero() : ((this$_429 = item(0, comp.Outputs), this$_429.BigIntSlab[(this$_429.StepBase + simStepOld)])), fromOne());
                    fd_115 = (equals(n_187, op_LeftShift(fromOne(), width_34)) ? fromZero() : n_187);
                    break;
                }
                default:
                    fd_115 = toFail(printf("CounterNoLoad received invalid enable value: %A"))(enable_5);
            }
            const this$_432 = item(0, comp.Outputs);
            this$_432.BigIntSlab[(this$_432.StepBase + simStep)] = fd_115;
            break;
        }
        case 74: {
            let fd_116;
            const width_36 = width_35 | 0;
            const next_3 = ((numStep === 0) ? 0 : ((this$_435 = item(0, comp.Outputs), this$_435.UInt32Slab[(this$_435.StepBase + simStepOld)]))) + 1;
            fd_116 = (((width_36 < 32) && (next_3 === ((1 << width_36) >>> 0))) ? 0 : next_3);
            const this$_434 = item(0, comp.Outputs);
            this$_434.UInt32Slab[(this$_434.StepBase + simStep)] = fd_116;
            break;
        }
        case 75: {
            const n_193 = op_Addition((numStep === 0) ? fromZero() : ((this$_436 = item(0, comp.Outputs), this$_436.BigIntSlab[(this$_436.StepBase + simStepOld)])), fromOne());
            const fd_117 = equals(n_193, op_LeftShift(fromOne(), width_37)) ? fromZero() : n_193;
            const this$_438 = item(0, comp.Outputs);
            this$_438.BigIntSlab[(this$_438.StepBase + simStep)] = fd_117;
            break;
        }
        case 76: {
            const fd_118 = readMemoryAddrUInt32DataUInt32(mem, (this$_439 = item(0, comp.InputLinks), this$_439.UInt32Slab[(this$_439.StepBase + simStep)]));
            const this$_441 = item(0, comp.Outputs);
            this$_441.UInt32Slab[(this$_441.StepBase + simStep)] = fd_118;
            break;
        }
        case 77: {
            const matchValue_114 = comp.BigIntState;
            if (matchValue_114 != null) {
                const outs_5 = matchValue_114.OutputIsBigInt;
                const matchValue_115 = item(0, matchValue_114.InputIsBigInt);
                const matchValue_116 = item(0, outs_5);
                if (matchValue_115) {
                    if (matchValue_116) {
                        const fd_119 = readMemoryAddrBigIntDataBigInt(mem_1, (this$_443 = item(0, comp.InputLinks), this$_443.BigIntSlab[(this$_443.StepBase + simStep)]));
                        const this$_445 = item(0, comp.Outputs);
                        this$_445.BigIntSlab[(this$_445.StepBase + simStep)] = fd_119;
                    }
                    else {
                        const fd_121 = readMemoryAddrBigIntDataUInt32(mem_1, (this$_449 = item(0, comp.InputLinks), this$_449.BigIntSlab[(this$_449.StepBase + simStep)]));
                        const this$_451 = item(0, comp.Outputs);
                        this$_451.UInt32Slab[(this$_451.StepBase + simStep)] = fd_121;
                    }
                }
                else if (matchValue_116) {
                    const fd_120 = readMemoryAddrUInt32DataBigInt(mem_1, (this$_446 = item(0, comp.InputLinks), this$_446.UInt32Slab[(this$_446.StepBase + simStep)]));
                    const this$_448 = item(0, comp.Outputs);
                    this$_448.BigIntSlab[(this$_448.StepBase + simStep)] = fd_120;
                }
                else {
                    const arg_153 = item(0, comp.InputLinks).Width | 0;
                    toFail(printf("ROM received data with wrong width: expected %d but got %A"))(mem_1.WordWidth)(arg_153);
                }
            }
            else {
                const arg_148 = item(0, comp.InputLinks).Width | 0;
                toFail(printf("ROM received data with wrong width: expected %d but got %A"))(mem_1.WordWidth)(arg_148);
            }
            break;
        }
        case 78: {
            const fd_122 = readMemoryAddrUInt32DataUInt32(mem_2, (numStep === 0) ? 0 : ((this$_454 = item(0, comp.InputLinks), this$_454.UInt32Slab[(this$_454.StepBase + simStepOld)])));
            const this$_456 = item(0, comp.Outputs);
            this$_456.UInt32Slab[(this$_456.StepBase + simStep)] = fd_122;
            break;
        }
        case 79: {
            const matchValue_118 = comp.BigIntState;
            if (matchValue_118 != null) {
                const outs_6 = matchValue_118.OutputIsBigInt;
                const matchValue_119 = item(0, matchValue_118.InputIsBigInt);
                const matchValue_120 = item(0, outs_6);
                if (matchValue_119) {
                    if (matchValue_120) {
                        const fd_123 = readMemoryAddrBigIntDataBigInt(mem_3, (this$_458 = item(0, comp.InputLinks), this$_458.BigIntSlab[(this$_458.StepBase + simStep)]));
                        const this$_460 = item(0, comp.Outputs);
                        this$_460.BigIntSlab[(this$_460.StepBase + simStep)] = fd_123;
                    }
                    else {
                        const fd_125 = readMemoryAddrBigIntDataUInt32(mem_3, (this$_464 = item(0, comp.InputLinks), this$_464.BigIntSlab[(this$_464.StepBase + simStep)]));
                        const this$_466 = item(0, comp.Outputs);
                        this$_466.UInt32Slab[(this$_466.StepBase + simStep)] = fd_125;
                    }
                }
                else if (matchValue_120) {
                    const fd_124 = readMemoryAddrUInt32DataBigInt(mem_3, (this$_461 = item(0, comp.InputLinks), this$_461.UInt32Slab[(this$_461.StepBase + simStep)]));
                    const this$_463 = item(0, comp.Outputs);
                    this$_463.BigIntSlab[(this$_463.StepBase + simStep)] = fd_124;
                }
                else {
                    const arg_162 = item(0, comp.InputLinks).Width | 0;
                    toFail(printf("ROM received data with wrong width: expected %d but got %A"))(mem_3.WordWidth)(arg_162);
                }
            }
            else {
                const arg_157 = item(0, comp.InputLinks).Width | 0;
                toFail(printf("ROM received data with wrong width: expected %d but got %A"))(mem_3.WordWidth)(arg_157);
            }
            break;
        }
        case 80: {
            let memState;
            if (numStep === 0) {
                const state = getRamState(simStep, comp.State);
                reset(ramStoreOf(state));
                memState = state;
            }
            else {
                memState = getRamState(simStepOld, comp.State);
            }
            const mem_4 = ramStoreOf(memState);
            let matchValue_122;
            if (numStep === 0) {
                matchValue_122 = 0;
            }
            else {
                const this$_469 = item(0, comp.InputLinks);
                matchValue_122 = (this$_469.UInt32Slab[(this$_469.StepBase + simStepOld)]);
            }
            let matchValue_123;
            if (numStep === 0) {
                matchValue_123 = 0;
            }
            else {
                const this$_471 = item(1, comp.InputLinks);
                matchValue_123 = (this$_471.UInt32Slab[(this$_471.StepBase + simStepOld)]);
            }
            let write;
            if (numStep === 0) {
                write = 0;
            }
            else {
                const this$_473 = item(2, comp.InputLinks);
                write = (this$_473.UInt32Slab[(this$_473.StepBase + simStepOld)]);
            }
            const address = matchValue_122;
            const dataOut = (numStep === 0) ? 0 : readRamAddrUInt32DataUInt32(mem_4, address);
            switch (write) {
                case 0: {
                    break;
                }
                case 1: {
                    writeRamAddrUInt32DataUInt32(mem_4, numStep, address, matchValue_123);
                    break;
                }
                default:
                    toFail(`simulation error: invalid 1 bit write value ${write}`);
            }
            const matchValue_125 = comp.State;
            if (matchValue_125 != null) {
                const stateArr = matchValue_125;
                stateArr.Step[simStep] = memState;
            }
            else {
                toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
            }
            const this$_475 = item(0, comp.Outputs);
            this$_475.UInt32Slab[(this$_475.StepBase + simStep)] = dataOut;
            break;
        }
        case 81: {
            let memState_1;
            if (numStep === 0) {
                const state_2 = getRamState(simStep, comp.State);
                reset(ramStoreOf(state_2));
                memState_1 = state_2;
            }
            else {
                memState_1 = getRamState(simStepOld, comp.State);
            }
            const mem_5 = ramStoreOf(memState_1);
            const matchValue_126 = comp.BigIntState;
            if (matchValue_126 != null) {
                const outs_7 = matchValue_126.OutputIsBigInt;
                const matchValue_127 = item(0, matchValue_126.InputIsBigInt);
                const matchValue_128 = item(0, outs_7);
                if (matchValue_127) {
                    if (matchValue_128) {
                        let matchValue_130;
                        if (numStep === 0) {
                            matchValue_130 = fromZero();
                        }
                        else {
                            const this$_479 = item(0, comp.InputLinks);
                            matchValue_130 = (this$_479.BigIntSlab[(this$_479.StepBase + simStepOld)]);
                        }
                        let matchValue_131;
                        if (numStep === 0) {
                            matchValue_131 = fromZero();
                        }
                        else {
                            const this$_481 = item(1, comp.InputLinks);
                            matchValue_131 = (this$_481.BigIntSlab[(this$_481.StepBase + simStepOld)]);
                        }
                        let write_1;
                        if (numStep === 0) {
                            write_1 = 0;
                        }
                        else {
                            const this$_483 = item(2, comp.InputLinks);
                            write_1 = (this$_483.UInt32Slab[(this$_483.StepBase + simStepOld)]);
                        }
                        const address_1 = matchValue_130;
                        const dataOut_1 = (numStep === 0) ? fromZero() : readRamAddrBigIntDataBigInt(mem_5, address_1);
                        switch (write_1) {
                            case 0: {
                                break;
                            }
                            case 1: {
                                writeRamAddrBigIntDataBigInt(mem_5, numStep, address_1, matchValue_131);
                                break;
                            }
                            default:
                                toFail(`simulation error: invalid 1 bit write value ${write_1}`);
                        }
                        const matchValue_133 = comp.State;
                        if (matchValue_133 != null) {
                            const stateArr_1 = matchValue_133;
                            stateArr_1.Step[simStep] = memState_1;
                        }
                        else {
                            toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                        }
                        const this$_485 = item(0, comp.Outputs);
                        this$_485.BigIntSlab[(this$_485.StepBase + simStep)] = dataOut_1;
                    }
                    else {
                        let matchValue_138;
                        if (numStep === 0) {
                            matchValue_138 = fromZero();
                        }
                        else {
                            const this$_495 = item(0, comp.InputLinks);
                            matchValue_138 = (this$_495.BigIntSlab[(this$_495.StepBase + simStepOld)]);
                        }
                        let matchValue_139;
                        if (numStep === 0) {
                            matchValue_139 = 0;
                        }
                        else {
                            const this$_497 = item(1, comp.InputLinks);
                            matchValue_139 = (this$_497.UInt32Slab[(this$_497.StepBase + simStepOld)]);
                        }
                        let write_3;
                        if (numStep === 0) {
                            write_3 = 0;
                        }
                        else {
                            const this$_499 = item(2, comp.InputLinks);
                            write_3 = (this$_499.UInt32Slab[(this$_499.StepBase + simStepOld)]);
                        }
                        const address_3 = matchValue_138;
                        const dataOut_3 = (numStep === 0) ? 0 : readRamAddrBigIntDataUInt32(mem_5, address_3);
                        switch (write_3) {
                            case 0: {
                                break;
                            }
                            case 1: {
                                writeRamAddrBigIntDataUInt32(mem_5, numStep, address_3, matchValue_139);
                                break;
                            }
                            default:
                                toFail(`simulation error: invalid 1 bit write value ${write_3}`);
                        }
                        const matchValue_141 = comp.State;
                        if (matchValue_141 != null) {
                            const stateArr_3 = matchValue_141;
                            stateArr_3.Step[simStep] = memState_1;
                        }
                        else {
                            toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                        }
                        const this$_501 = item(0, comp.Outputs);
                        this$_501.UInt32Slab[(this$_501.StepBase + simStep)] = dataOut_3;
                    }
                }
                else if (matchValue_128) {
                    let matchValue_134;
                    if (numStep === 0) {
                        matchValue_134 = 0;
                    }
                    else {
                        const this$_487 = item(0, comp.InputLinks);
                        matchValue_134 = (this$_487.UInt32Slab[(this$_487.StepBase + simStepOld)]);
                    }
                    let matchValue_135;
                    if (numStep === 0) {
                        matchValue_135 = fromZero();
                    }
                    else {
                        const this$_489 = item(1, comp.InputLinks);
                        matchValue_135 = (this$_489.BigIntSlab[(this$_489.StepBase + simStepOld)]);
                    }
                    let write_2;
                    if (numStep === 0) {
                        write_2 = 0;
                    }
                    else {
                        const this$_491 = item(2, comp.InputLinks);
                        write_2 = (this$_491.UInt32Slab[(this$_491.StepBase + simStepOld)]);
                    }
                    const address_2 = matchValue_134;
                    const dataOut_2 = (numStep === 0) ? fromZero() : readRamAddrUInt32DataBigInt(mem_5, address_2);
                    switch (write_2) {
                        case 0: {
                            break;
                        }
                        case 1: {
                            writeRamAddrUInt32DataBigInt(mem_5, numStep, address_2, matchValue_135);
                            break;
                        }
                        default:
                            toFail(`simulation error: invalid 1 bit write value ${write_2}`);
                    }
                    const matchValue_137 = comp.State;
                    if (matchValue_137 != null) {
                        const stateArr_2 = matchValue_137;
                        stateArr_2.Step[simStep] = memState_1;
                    }
                    else {
                        toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                    }
                    const this$_493 = item(0, comp.Outputs);
                    this$_493.BigIntSlab[(this$_493.StepBase + simStep)] = dataOut_2;
                }
                else {
                    const arg_171 = item(0, comp.InputLinks).Width | 0;
                    toFail(printf("RAM received data with wrong width: expected %d but got %A"))(mem_5.WordWidth)(arg_171);
                }
            }
            else {
                const arg_169 = item(0, comp.InputLinks).Width | 0;
                toFail(printf("RAM received data with wrong width: expected %d but got %A"))(mem_5.WordWidth)(arg_169);
            }
            break;
        }
        case 82: {
            if (isClockedReduction) {
                let memState_2;
                if (numStep === 0) {
                    const state_6 = getRamState(simStep, comp.State);
                    reset(ramStoreOf(state_6));
                    memState_2 = state_6;
                }
                else {
                    memState_2 = getRamState(simStepOld, comp.State);
                }
                const mem_6 = ramStoreOf(memState_2);
                let matchValue_142;
                if (numStep === 0) {
                    matchValue_142 = 0;
                }
                else {
                    const this$_503 = item(0, comp.InputLinks);
                    matchValue_142 = (this$_503.UInt32Slab[(this$_503.StepBase + simStepOld)]);
                }
                let matchValue_143;
                if (numStep === 0) {
                    matchValue_143 = 0;
                }
                else {
                    const this$_505 = item(1, comp.InputLinks);
                    matchValue_143 = (this$_505.UInt32Slab[(this$_505.StepBase + simStepOld)]);
                }
                let write_4;
                if (numStep === 0) {
                    write_4 = 0;
                }
                else {
                    const this$_507 = item(2, comp.InputLinks);
                    write_4 = (this$_507.UInt32Slab[(this$_507.StepBase + simStepOld)]);
                }
                switch (write_4) {
                    case 0: {
                        break;
                    }
                    case 1: {
                        writeRamAddrUInt32DataUInt32(mem_6, numStep, matchValue_142, matchValue_143);
                        break;
                    }
                    default:
                        toFail(`simulation error: invalid 1 bit write value ${write_4}`);
                }
                const matchValue_145 = comp.State;
                if (matchValue_145 != null) {
                    const stateArr_4 = matchValue_145;
                    stateArr_4.Step[simStep] = memState_2;
                }
                else {
                    toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                }
            }
            else {
                const fd_130 = readRamAddrUInt32DataUInt32(getRamStore(simStep, comp.State), (this$_508 = item(0, comp.InputLinks), this$_508.UInt32Slab[(this$_508.StepBase + simStep)]));
                const this$_510 = item(0, comp.Outputs);
                this$_510.UInt32Slab[(this$_510.StepBase + simStep)] = fd_130;
            }
            break;
        }
        case 83: {
            const matchValue_146 = comp.BigIntState;
            if (matchValue_146 != null) {
                const outs_8 = matchValue_146.OutputIsBigInt;
                const matchValue_147 = item(0, matchValue_146.InputIsBigInt);
                const matchValue_148 = item(0, outs_8);
                if (matchValue_147) {
                    if (matchValue_148) {
                        if (isClockedReduction) {
                            let memState_3;
                            if (numStep === 0) {
                                const state_8 = getRamState(simStep, comp.State);
                                reset(ramStoreOf(state_8));
                                memState_3 = state_8;
                            }
                            else {
                                memState_3 = getRamState(simStepOld, comp.State);
                            }
                            const mem_9 = ramStoreOf(memState_3);
                            let matchValue_150;
                            if (numStep === 0) {
                                matchValue_150 = fromZero();
                            }
                            else {
                                const this$_514 = item(0, comp.InputLinks);
                                matchValue_150 = (this$_514.BigIntSlab[(this$_514.StepBase + simStepOld)]);
                            }
                            let matchValue_151;
                            if (numStep === 0) {
                                matchValue_151 = fromZero();
                            }
                            else {
                                const this$_516 = item(1, comp.InputLinks);
                                matchValue_151 = (this$_516.BigIntSlab[(this$_516.StepBase + simStepOld)]);
                            }
                            let write_5;
                            if (numStep === 0) {
                                write_5 = 0;
                            }
                            else {
                                const this$_518 = item(2, comp.InputLinks);
                                write_5 = (this$_518.UInt32Slab[(this$_518.StepBase + simStepOld)]);
                            }
                            switch (write_5) {
                                case 0: {
                                    break;
                                }
                                case 1: {
                                    writeRamAddrBigIntDataBigInt(mem_9, numStep, matchValue_150, matchValue_151);
                                    break;
                                }
                                default:
                                    toFail(`simulation error: invalid 1 bit write value ${write_5}`);
                            }
                            const matchValue_153 = comp.State;
                            if (matchValue_153 != null) {
                                const stateArr_5 = matchValue_153;
                                stateArr_5.Step[simStep] = memState_3;
                            }
                            else {
                                toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                            }
                        }
                        else {
                            const fd_131 = readRamAddrBigIntDataBigInt(getRamStore(simStep, comp.State), (this$_519 = item(0, comp.InputLinks), this$_519.BigIntSlab[(this$_519.StepBase + simStep)]));
                            const this$_521 = item(0, comp.Outputs);
                            this$_521.BigIntSlab[(this$_521.StepBase + simStep)] = fd_131;
                        }
                    }
                    else if (isClockedReduction) {
                        let memState_5;
                        if (numStep === 0) {
                            const state_12 = getRamState(simStep, comp.State);
                            reset(ramStoreOf(state_12));
                            memState_5 = state_12;
                        }
                        else {
                            memState_5 = getRamState(simStepOld, comp.State);
                        }
                        const mem_13 = ramStoreOf(memState_5);
                        let matchValue_158;
                        if (numStep === 0) {
                            matchValue_158 = fromZero();
                        }
                        else {
                            const this$_532 = item(0, comp.InputLinks);
                            matchValue_158 = (this$_532.BigIntSlab[(this$_532.StepBase + simStepOld)]);
                        }
                        let matchValue_159;
                        if (numStep === 0) {
                            matchValue_159 = 0;
                        }
                        else {
                            const this$_534 = item(1, comp.InputLinks);
                            matchValue_159 = (this$_534.UInt32Slab[(this$_534.StepBase + simStepOld)]);
                        }
                        let write_7;
                        if (numStep === 0) {
                            write_7 = 0;
                        }
                        else {
                            const this$_536 = item(2, comp.InputLinks);
                            write_7 = (this$_536.UInt32Slab[(this$_536.StepBase + simStepOld)]);
                        }
                        switch (write_7) {
                            case 0: {
                                break;
                            }
                            case 1: {
                                writeRamAddrBigIntDataUInt32(mem_13, numStep, matchValue_158, matchValue_159);
                                break;
                            }
                            default:
                                toFail(`simulation error: invalid 1 bit write value ${write_7}`);
                        }
                        const matchValue_161 = comp.State;
                        if (matchValue_161 != null) {
                            const stateArr_7 = matchValue_161;
                            stateArr_7.Step[simStep] = memState_5;
                        }
                        else {
                            toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                        }
                    }
                    else {
                        const fd_133 = readRamAddrBigIntDataUInt32(getRamStore(simStep, comp.State), (this$_537 = item(0, comp.InputLinks), this$_537.BigIntSlab[(this$_537.StepBase + simStep)]));
                        const this$_539 = item(0, comp.Outputs);
                        this$_539.UInt32Slab[(this$_539.StepBase + simStep)] = fd_133;
                    }
                }
                else if (matchValue_148) {
                    if (isClockedReduction) {
                        let memState_4;
                        if (numStep === 0) {
                            const state_10 = getRamState(simStep, comp.State);
                            reset(ramStoreOf(state_10));
                            memState_4 = state_10;
                        }
                        else {
                            memState_4 = getRamState(simStepOld, comp.State);
                        }
                        const mem_11 = ramStoreOf(memState_4);
                        let matchValue_154;
                        if (numStep === 0) {
                            matchValue_154 = 0;
                        }
                        else {
                            const this$_523 = item(0, comp.InputLinks);
                            matchValue_154 = (this$_523.UInt32Slab[(this$_523.StepBase + simStepOld)]);
                        }
                        let matchValue_155;
                        if (numStep === 0) {
                            matchValue_155 = fromZero();
                        }
                        else {
                            const this$_525 = item(1, comp.InputLinks);
                            matchValue_155 = (this$_525.BigIntSlab[(this$_525.StepBase + simStepOld)]);
                        }
                        let write_6;
                        if (numStep === 0) {
                            write_6 = 0;
                        }
                        else {
                            const this$_527 = item(2, comp.InputLinks);
                            write_6 = (this$_527.UInt32Slab[(this$_527.StepBase + simStepOld)]);
                        }
                        switch (write_6) {
                            case 0: {
                                break;
                            }
                            case 1: {
                                writeRamAddrUInt32DataBigInt(mem_11, numStep, matchValue_154, matchValue_155);
                                break;
                            }
                            default:
                                toFail(`simulation error: invalid 1 bit write value ${write_6}`);
                        }
                        const matchValue_157 = comp.State;
                        if (matchValue_157 != null) {
                            const stateArr_6 = matchValue_157;
                            stateArr_6.Step[simStep] = memState_4;
                        }
                        else {
                            toFail(printf("Attempt to put state into component %s without state array"))(comp.FullName);
                        }
                    }
                    else {
                        const fd_132 = readRamAddrUInt32DataBigInt(getRamStore(simStep, comp.State), (this$_528 = item(0, comp.InputLinks), this$_528.UInt32Slab[(this$_528.StepBase + simStep)]));
                        const this$_530 = item(0, comp.Outputs);
                        this$_530.BigIntSlab[(this$_530.StepBase + simStep)] = fd_132;
                    }
                }
                else {
                    const arg_195 = item(0, comp.InputLinks).Width | 0;
                    toFail(printf("RAM received data with wrong width: expected %d but got %A"))(mem_8.WordWidth)(arg_195);
                }
            }
            else {
                const arg_193 = item(0, comp.InputLinks).Width | 0;
                toFail(printf("RAM received data with wrong width: expected %d but got %A"))(mem_8.WordWidth)(arg_193);
            }
            break;
        }
        case 84: {
            toFail(`simulation error: deprecated component type ${componentType}`);
            break;
        }
    }
}

/**
 * fastReduce for a one-off reduction, working out the step indices for itself. Anything
 * reducing many components, or the same component over many steps, should compute them once
 * with simStepOf and simStepOldOf and call fastReduce directly.
 */
export function fastReduceStep(maxArraySize, numStep, isClockedReduction, comp) {
    let maxArraySize_1, numStep_1, simStep;
    fastReduce((maxArraySize_1 = (maxArraySize | 0), (numStep_1 = (numStep | 0), (simStep = ((numStep_1 % maxArraySize_1) | 0), new StepIndex(numStep_1, simStep, (simStep === 0) ? (maxArraySize_1 - 1) : (simStep - 1))))), isClockedReduction, comp);
}

